/**
 * Industry Categories for different search types
 * Maps Search and Handelsregister (Commercial Register) Search
 */

// Google Maps Search Industry Categories
export const MAPS_SEARCH_INDUSTRY_CATEGORIES = [
	'3D-Druck',
	'Abbruchunternehmen',
	'Abfallwirtschaft',
	'Abrissunternehmen',
	'Additive Fertigung',
	'Agrartechnik',
	'Akupunkteur',
	'Allergologe',
	'Aluminiumverarbeitung',
	'Anästhesist',
	'Anlagenbau',
	'Apotheke',
	'Architekt',
	'Architekturbüro',
	'Arzt',
	'Atelier',
	'Audiologe',
	'Auditorium',
	'Augenarzt',
	'Autohaus',
	'Automatisierungstechnik',
	'Automobilbau',
	'Automobilindustrie',
	'Automobilzulieferer',
	'Autolackiererei',
	'Bäckerei',
	'Ballettschule',
	'Bank',
	'Bankfiliale',
	'Bar',
	'Batterietechnik',
	'Bauchemie',
	'Bauernhof',
	'Bauingenieur',
	'Baumaschinenhandel',
	'Baumschule',
	'Baustoffhandel',
	'Bauunternehmen',
	'Betonindustrie',
	'Bibliothek',
	'Blechbearbeitung',
	'Bohrtechnik',
	'Bootsbauer',
	'Bootshändler',
	'Bootsclub',
	'Boutique',
	'Bowlingcenter',
	'Brauerei',
	'Brauhaus',
	'Buchbinder',
	'Buchhalter',
	'CAD-Dienstleistung',
	'Café',
	'Campingplatz',
	'Cannabisgeschäft',
	'Casino',
	'Catering',
	'Chemische Industrie',
	'Chiropraktiker',
	'Cloud-Computing',
	'CNC-Bearbeitung',
	'CNC-Drehen',
	'CNC-Fräsen',
	'Computerladen',
	'Coworking-Space',
	'Cybersicherheit',
	'Dachdeckerei',
	'Datenanalyse',
	'Designagentur',
	'Dermatologe',
	'DJ',
	'Dichtungstechnik',
	'Disco',
	'Drehtechnik',
	'Drogerie',
	'Druckerei',
	'E-Commerce-Agentur',
	'Edelstahlverarbeitung',
	'Elektriker',
	'Energietechnik',
	'Entsorgungsunternehmen',
	'Ernährungsberater',
	'ERP-Integration',
	'Facility-Management',
	'Fahrradindustrie',
	'Fahrwerkstechnik',
	'Fassadenbau',
	'Feinmechanik',
	'Feinwerktechnik',
	'Feinkostgeschäft',
	'Ferienhaus',
	'Fertigungstechnik',
	'Filtrationstechnik',
	'Finanzdienstleister',
	'Fitnessstudio',
	'Florist',
	'Flughafen',
	'Flugsportverein',
	'Flugzeugbau',
	'Fördertechnik',
	'Freizeitpark',
	'Friseur',
	'Gabelstaplertechnik',
	'Galvanotechnik',
	'Gebäudetechnik',
	'Gärtner',
	'Gastroenterologe',
	'Geotechnik',
	'Gerätebau',
	'Getränketechnologie',
	'Gießerei',
	'Glaser',
	'Glasverarbeitung',
	'Goldschmied',
	'Golfclub',
	'Gummitechnik',
	'Gynäkologe',
	'Handwerker',
	'Hebamme',
	'Heizungstechnik',
	'HNO-Arzt',
	'Holzverarbeitung',
	'Homöopath',
	'Hostel',
	'Hydraulik',
	'Hundepension',
	'Immunologe',
	'Immobilienmakler',
	'Industrieautomation',
	'Industriemontage',
	'Industrierobotik',
	'Ingenieurbüro',
	'Internist',
	'IT-Dienstleister',
	'IT-Systemhaus',
	'Kabeltechnik',
	'Kampfsportschule',
	'Kapselhotel',
	'Kardiologe',
	'Karosseriebau',
	'Kieferorthopäde',
	'Kindergarten',
	'Kinesiologe',
	'Kirche',
	'Kiosk',
	'Klimatechnik',
	'Kältetechnik',
	'Klinik',
	'Kloster',
	'Konditorei',
	'Konstruktion',
	'Kosmetiker',
	'Krankenhaus',
	'Künstler',
	'Kunsthändler',
	'Kunststoffverarbeitung',
	'Labortechnik',
	'Lagerlogistik',
	'Landmaschinenhandel',
	'Landwirtschaftsbetrieb',
	'Landschaftsgärtner',
	'Laserschneiden',
	'Laserschweißen',
	'Lasertechnik',
	'Lebensmittelindustrie',
	'Lohnfertigung',
	'Luft- und Raumfahrtunternehmen',
	'Luftfahrt',
	'Lüftungstechnik',
	'Maler',
	'Maschinenbau',
	'Maschinenhandel',
	'Materialprüfung',
	'Maurer',
	'Medienagentur',
	'Medizintechnik',
	'Messtechnik',
	'Metallbau',
	'Metallbearbeitung',
	'Molkerei',
	'Möbelhaus',
	'Möbelindustrie',
	'Musikindustrie',
	'Museum',
	'Nanotechnologie',
	'Neurologe',
	'Nutzfahrzeugbau',
	'Oberflächenbehandlung',
	'Oberflächenbeschichtung',
	'Oberflächentechnik',
	'Onkologe',
	'Online-Marketing-Agentur',
	'Optiker',
	'Pharmatechnik',
	'Physiotherapeut',
	'Planetarium',
	'Pneumatik',
	'Präzisionsdrehtechnik',
	'Präzisionsmechanik',
	'Präzisionstechnik',
	'Privatdetektiv',
	'Projektmanagement',
	'Psychiater',
	'Pumpen- und Armaturentechnik',
	'Qualitätssicherung',
	'Radiologe',
	'Rechenzentrum',
	'Rechtsanwalt',
	'Rechtsanwaltskanzlei',
	'Recyclingfirma',
	'Reinigungstechnik',
	'Reinigungsfirma',
	'SAP-Integration',
	'Sägetechnik',
	'Schienenfahrzeugtechnik',
	'Schiffbau',
	'Schleiftechnik',
	'Schlüsseldienst',
	'Schmied',
	'Schmiedetechnik',
	'Schneider',
	'Schraubentechnik',
	'Schreiner',
	'Schuhgeschäft',
	'Schweißer',
	'Sensortechnik',
	'Sicherheitsdienst',
	'Sicherheitstechnik',
	'Softwareentwicklung',
	'Sonderanlagenbau',
	'Spa',
	'Spedition',
	'Sportgeschäft',
	'Spritzguss',
	'Stahl- und Metallbau',
	'Stahlverarbeitung',
	'Steinbruch',
	'Steuerberater',
	'Supermarkt',
	'Systemgastronomie',
	'Systemintegration',
	'Tankstelle',
	'Tanzrestaurant',
	'Tattoo-Studio',
	'Tätowierer',
	'Telekommunikationsunternehmen',
	'Teppichgeschäft',
	'Testamentsvollstrecker',
	'Thermoplast- und Duroplastverarbeitung',
	'Tiefbau',
	'Tierarzt',
	'Tierheim',
	'Tierpark',
	'Tischler',
	'Transportunternehmen',
	'Übersetzer',
	'Umformtechnik',
	'Umweltberater',
	'Umwelttechnik',
	'Unternehmensberatung',
	'Uhrengeschäft',
	'Vakuumtechnik',
	'Veranstaltungstechnik',
	'Verlag',
	'Ventiltechnik',
	'Verpackungsmaschinenbau',
	'Verpackungstechnik',
	'Versandhandel',
	'Verschleißschutz',
	'Verzinkerei',
	'Videoagentur',
	'Walztechnik',
	'Waschsalon',
	'Wasser- und Abwassertechnik',
	'Wasserstofftechnik',
	'Wälzlagertechnik',
	'Web-Agentur',
	'Webdesigner',
	'Weingut',
	'Werbeagentur',
	'Werbefotograf',
	'Werkstoffprüfung',
	'Werkzeugbau',
	'Werkzeughandel',
	'Werkzeugschleiferei',
	'Windenergie',
	'Wirtschaftsprüfer',
	'Zahnarzt',
	'Zerspanungstechnik',
	'Zimmerei',
	'Zirkus',
];

/* HR SEARCH categories (WZ2025) */
export const HR_SEARCH_INDUSTRY_CATEGORIES = [
	{
		id: 'A',
		name: 'Land- und Forstwirtschaft, Fischerei',
		code: '01-03',
		subcategories: [
			{ id: '01', name: 'Landwirtschaft, Jagd und damit verbundene Tätigkeiten', code: '01' },
			{ id: '01.1', name: 'Anbau ein- und zweijähriger Pflanzen', code: '01.1' },
			{
				id: '01.11',
				name: 'Anbau von anderem Getreide als Reis sowie von Hülsenfrüchten und Ölsaaten',
				code: '01.11',
			},
			{ id: '01.12', name: 'Anbau von Reis', code: '01.12' },
			{ id: '01.13', name: 'Anbau von Gemüse und Melonen sowie Wurzeln und Knollen', code: '01.13' },
			{ id: '01.14', name: 'Anbau von Zuckerrohr', code: '01.14' },
			{ id: '01.15', name: 'Anbau von Tabak', code: '01.15' },
			{ id: '01.16', name: 'Anbau von Faserpflanzen', code: '01.16' },
			{ id: '01.19', name: 'Anbau von sonstigen ein- und zweijährigen Pflanzen', code: '01.19' },
			{ id: '01.2', name: 'Anbau mehrjähriger Pflanzen', code: '01.2' },
			{ id: '01.21', name: 'Anbau von Wein- und Tafeltrauben', code: '01.21' },
			{ id: '01.22', name: 'Anbau von tropischen und subtropischen Früchten', code: '01.22' },
			{ id: '01.23', name: 'Anbau von Zitrusfrüchten', code: '01.23' },
			{ id: '01.24', name: 'Anbau von Kern- und Steinobst', code: '01.24' },
			{ id: '01.25', name: 'Anbau von sonstigem Obst und Nüssen', code: '01.25' },
			{ id: '01.26', name: 'Anbau von ölhaltigen Früchten', code: '01.26' },
			{ id: '01.27', name: 'Anbau von Pflanzen zur Herstellung von Getränken', code: '01.27' },
			{
				id: '01.28',
				name: 'Anbau von Gewürzpflanzen, Pflanzen für aromatische, narkotische und pharmazeutische Zwecke',
				code: '01.28',
			},
			{ id: '01.29', name: 'Anbau sonstiger mehrjähriger Pflanzen', code: '01.29' },
			{
				id: '01.3',
				name: 'Betrieb von Baumschulen sowie Anbau von Pflanzen zu Vermehrungszwecken',
				code: '01.3',
			},
			{
				id: '01.30',
				name: 'Betrieb von Baumschulen sowie Anbau von Pflanzen zu Vermehrungszwecken',
				code: '01.30',
			},
			{ id: '01.4', name: 'Tierhaltung', code: '01.4' },
			{ id: '01.41', name: 'Haltung von Milchkühen', code: '01.41' },
			{ id: '01.42', name: 'Haltung von sonstigen Rindern', code: '01.42' },
			{ id: '01.43', name: 'Haltung von Pferden und Eseln', code: '01.43' },
			{ id: '01.44', name: 'Haltung von Kamelen', code: '01.44' },
			{ id: '01.45', name: 'Haltung von Schafen und Ziegen', code: '01.45' },
			{ id: '01.46', name: 'Haltung von Schweinen', code: '01.46' },
			{ id: '01.47', name: 'Haltung von Geflügel', code: '01.47' },
			{ id: '01.48', name: 'Sonstige Tierhaltung', code: '01.48' },
			{ id: '01.5', name: 'Gemischte Landwirtschaft', code: '01.5' },
			{ id: '01.50', name: 'Gemischte Landwirtschaft', code: '01.50' },
			{
				id: '01.6',
				name: 'Erbringung von landwirtschaftlichen Dienstleistungen und nach der Ernte anfallende Tätigkeiten',
				code: '01.6',
			},
			{
				id: '01.61',
				name: 'Erbringung von landwirtschaftlichen Dienstleistungen für den Pflanzenbau',
				code: '01.61',
			},
			{
				id: '01.62',
				name: 'Erbringung von landwirtschaftlichen Dienstleistungen für die Tierhaltung',
				code: '01.62',
			},
			{
				id: '01.63',
				name: 'Nach der Ernte anfallende Tätigkeiten in der pflanzlichen Erzeugung und Saatgutaufbereitung',
				code: '01.63',
			},
			{ id: '01.7', name: 'Jagd, Fallenstellerei und damit verbundene Tätigkeiten', code: '01.7' },
			{ id: '01.70', name: 'Jagd, Fallenstellerei und damit verbundene Tätigkeiten', code: '01.70' },
			{ id: '02', name: 'Forstwirtschaft und Holzeinschlag', code: '02' },
			{ id: '02.1', name: 'Forstwirtschaft', code: '02.1' },
			{ id: '02.10', name: 'Forstwirtschaft', code: '02.10' },
			{ id: '02.2', name: 'Holzeinschlag', code: '02.2' },
			{ id: '02.20', name: 'Holzeinschlag', code: '02.20' },
			{ id: '02.3', name: 'Sammeln von wildwachsenden Produkten, ohne Holz', code: '02.3' },
			{ id: '02.30', name: 'Sammeln von wildwachsenden Produkten, ohne Holz', code: '02.30' },
			{ id: '02.4', name: 'Erbringung von Dienstleistungen für Forstwirtschaft und Holzeinschlag', code: '02.4' },
			{
				id: '02.40',
				name: 'Erbringung von Dienstleistungen für Forstwirtschaft und Holzeinschlag',
				code: '02.40',
			},
			{ id: '03', name: 'Fischerei und Aquakultur', code: '03' },
			{ id: '03.1', name: 'Fischerei', code: '03.1' },
			{ id: '03.11', name: 'Meeresfischerei', code: '03.11' },
			{ id: '03.12', name: 'Süßwasserfischerei', code: '03.12' },
			{ id: '03.2', name: 'Aquakultur', code: '03.2' },
			{ id: '03.21', name: 'Meeresaquakultur', code: '03.21' },
			{ id: '03.22', name: 'Süßwasseraquakultur', code: '03.22' },
			{ id: '03.3', name: 'Erbringung von Dienstleistungen für Fischerei und Aquakultur', code: '03.3' },
			{ id: '03.30', name: 'Erbringung von Dienstleistungen für Fischerei und Aquakultur', code: '03.30' },
		],
	},
	{
		id: 'B',
		name: 'Bergbau und Gewinnung von Steinen und Erden',
		code: '05-09',
		subcategories: [
			{ id: '05', name: 'Kohlenbergbau', code: '05' },
			{ id: '05.1', name: 'Steinkohlenbergbau', code: '05.1' },
			{ id: '05.10', name: 'Steinkohlenbergbau', code: '05.10' },
			{ id: '05.2', name: 'Braunkohlenbergbau', code: '05.2' },
			{ id: '05.20', name: 'Braunkohlenbergbau', code: '05.20' },
			{ id: '06', name: 'Gewinnung von Erdöl und Erdgas', code: '06' },
			{ id: '06.1', name: 'Gewinnung von Erdöl', code: '06.1' },
			{ id: '06.10', name: 'Gewinnung von Erdöl', code: '06.10' },
			{ id: '06.2', name: 'Gewinnung von Erdgas', code: '06.2' },
			{ id: '06.20', name: 'Gewinnung von Erdgas', code: '06.20' },
			{ id: '07', name: 'Erzbergbau', code: '07' },
			{ id: '07.1', name: 'Eisenerzbergbau', code: '07.1' },
			{ id: '07.10', name: 'Eisenerzbergbau', code: '07.10' },
			{ id: '07.2', name: 'NE-Metallerzbergbau', code: '07.2' },
			{ id: '07.21', name: 'Bergbau auf Uran- und Thoriumerze', code: '07.21' },
			{ id: '07.29', name: 'Sonstiger NE-Metallerzbergbau', code: '07.29' },
			{ id: '08', name: 'Gewinnung von Steinen und Erden, sonstiger Bergbau', code: '08' },
			{ id: '08.1', name: 'Gewinnung von Natursteinen, Kies, Sand, Ton und Kaolin', code: '08.1' },
			{
				id: '08.11',
				name: 'Gewinnung von Naturwerksteinen, Kalk- und Gipsstein, Schiefer und sonstigem Gestein',
				code: '08.11',
			},
			{ id: '08.12', name: 'Gewinnung von Kies und Sand, Ton und Kaolin', code: '08.12' },
			{ id: '08.9', name: 'Sonstiger Bergbau; Gewinnung von Steinen und Erden a. n. g.', code: '08.9' },
			{ id: '08.91', name: 'Bergbau auf chemische und Düngemittelminerale', code: '08.91' },
			{ id: '08.92', name: 'Torfgewinnung', code: '08.92' },
			{ id: '08.93', name: 'Gewinnung von Salz', code: '08.93' },
			{ id: '08.99', name: 'Gewinnung von Steinen und Erden a. n. g.', code: '08.99' },
			{
				id: '09',
				name: 'Erbringung von Dienstleistungen für den Bergbau und für die Gewinnung von Steinen und Erden',
				code: '09',
			},
			{
				id: '09.1',
				name: 'Erbringung von Dienstleistungen für die Gewinnung von Erdöl und Erdgas',
				code: '09.1',
			},
			{
				id: '09.10',
				name: 'Erbringung von Dienstleistungen für die Gewinnung von Erdöl und Erdgas',
				code: '09.10',
			},
			{
				id: '09.9',
				name: 'Erbringung von Dienstleistungen für den sonstigen Bergbau und die Gewinnung von Steinen und Erden',
				code: '09.9',
			},
			{
				id: '09.90',
				name: 'Erbringung von Dienstleistungen für den sonstigen Bergbau und die Gewinnung von Steinen und Erden',
				code: '09.90',
			},
		],
	},
	{
		id: 'C',
		name: 'Verarbeitendes Gewerbe',
		code: '10-33',
		subcategories: [
			{ id: '10', name: 'Herstellung von Nahrungs- und Futtermitteln', code: '10' },
			{ id: '10.1', name: 'Schlachten und Fleischverarbeitung', code: '10.1' },
			{ id: '10.11', name: 'Schlachten, ohne Schlachten von Geflügel', code: '10.11' },
			{ id: '10.12', name: 'Schlachten von Geflügel', code: '10.12' },
			{ id: '10.13', name: 'Fleischverarbeitung', code: '10.13' },
			{ id: '10.2', name: 'Fischverarbeitung', code: '10.2' },
			{ id: '10.20', name: 'Fischverarbeitung', code: '10.20' },
			{ id: '10.3', name: 'Obst- und Gemüseverarbeitung', code: '10.3' },
			{ id: '10.31', name: 'Kartoffelverarbeitung', code: '10.31' },
			{ id: '10.32', name: 'Herstellung von Frucht- und Gemüsesäften', code: '10.32' },
			{ id: '10.39', name: 'Sonstige Verarbeitung von Obst und Gemüse', code: '10.39' },
			{ id: '10.4', name: 'Herstellung von pflanzlichen und tierischen Ölen und Fetten', code: '10.4' },
			{ id: '10.41', name: 'Herstellung von Ölen und Fetten, ohne Margarine u. ä. Nahrungsfette', code: '10.41' },
			{ id: '10.42', name: 'Herstellung von Margarine u. ä. Nahrungsfetten', code: '10.42' },
			{ id: '10.5', name: 'Herstellung von Milcherzeugnissen und Speiseeis', code: '10.5' },
			{ id: '10.51', name: 'Herstellung von Milcherzeugnissen', code: '10.51' },
			{ id: '10.52', name: 'Herstellung von Speiseeis', code: '10.52' },
			{ id: '10.6', name: 'Mahl- und Schälmühlen, Herstellung von Stärke und Stärkeerzeugnissen', code: '10.6' },
			{ id: '10.61', name: 'Mahl- und Schälmühlen', code: '10.61' },
			{ id: '10.62', name: 'Herstellung von Stärke und Stärkeerzeugnissen', code: '10.62' },
			{ id: '10.7', name: 'Herstellung von Back- und Teigwaren', code: '10.7' },
			{ id: '10.71', name: 'Herstellung von Backwaren, ohne Dauerbackwaren', code: '10.71' },
			{ id: '10.72', name: 'Herstellung von Dauerbackwaren', code: '10.72' },
			{ id: '10.73', name: 'Herstellung von Teigwaren', code: '10.73' },
			{ id: '10.8', name: 'Herstellung von sonstigen Nahrungsmitteln', code: '10.8' },
			{ id: '10.81', name: 'Herstellung von Zucker', code: '10.81' },
			{ id: '10.82', name: 'Herstellung von Süßwaren, ohne Dauerbackwaren', code: '10.82' },
			{ id: '10.83', name: 'Verarbeitung von Kaffee und Tee, Herstellung von Kaffee-Ersatz', code: '10.83' },
			{ id: '10.84', name: 'Herstellung von Würzmitteln und Soßen', code: '10.84' },
			{ id: '10.85', name: 'Herstellung von Fertiggerichten', code: '10.85' },
			{ id: '10.86', name: 'Herstellung von homogenisierten und diätetischen Nahrungsmitteln', code: '10.86' },
			{ id: '10.89', name: 'Herstellung von sonstigen Nahrungsmitteln a. n. g.', code: '10.89' },
			{ id: '10.9', name: 'Herstellung von Futtermitteln', code: '10.9' },
			{ id: '10.91', name: 'Herstellung von Futtermitteln für Nutztiere', code: '10.91' },
			{ id: '10.92', name: 'Herstellung von Futtermitteln für sonstige Tiere', code: '10.92' },
			{ id: '11', name: 'Getränkeherstellung', code: '11' },
			{ id: '11.0', name: 'Getränkeherstellung', code: '11.0' },
			{ id: '11.01', name: 'Herstellung von Spirituosen', code: '11.01' },
			{ id: '11.02', name: 'Herstellung von Traubenwein', code: '11.02' },
			{
				id: '11.03',
				name: 'Herstellung von Apfelwein und sonstigen gegorenen Getränken aus Obst',
				code: '11.03',
			},
			{ id: '11.04', name: 'Herstellung von Wermutwein und sonstigen aromatisierten Weinen', code: '11.04' },
			{ id: '11.05', name: 'Herstellung von Bier', code: '11.05' },
			{ id: '11.06', name: 'Herstellung von Malz', code: '11.06' },
			{ id: '11.07', name: 'Herstellung von Erfrischungsgetränken und Mineralwässern', code: '11.07' },
			{ id: '12', name: 'Tabakverarbeitung', code: '12' },
			{ id: '12.0', name: 'Tabakverarbeitung', code: '12.0' },
			{ id: '12.00', name: 'Tabakverarbeitung', code: '12.00' },
			{ id: '13', name: 'Herstellung von Textilien', code: '13' },
			{ id: '13.1', name: 'Spinnstoffaufbereitung und Spinnerei', code: '13.1' },
			{ id: '13.10', name: 'Spinnstoffaufbereitung und Spinnerei', code: '13.10' },
			{ id: '13.2', name: 'Weberei', code: '13.2' },
			{ id: '13.20', name: 'Weberei', code: '13.20' },
			{ id: '13.3', name: 'Veredlung von Textilien und Bekleidung', code: '13.3' },
			{ id: '13.30', name: 'Veredlung von Textilien und Bekleidung', code: '13.30' },
			{ id: '13.9', name: 'Herstellung von sonstigen Textilwaren', code: '13.9' },
			{ id: '13.91', name: 'Herstellung von gewirktem und gestricktem Stoff', code: '13.91' },
			{
				id: '13.92',
				name: 'Herstellung von Heimtextilien und konfektionierten Textilwaren für die Innenausstattung',
				code: '13.92',
			},
			{ id: '13.93', name: 'Herstellung von Teppichen', code: '13.93' },
			{ id: '13.94', name: 'Herstellung von Seilerwaren', code: '13.94' },
			{
				id: '13.95',
				name: 'Herstellung von Vliesstoff und nicht-konfektionierten Erzeugnissen daraus',
				code: '13.95',
			},
			{ id: '13.96', name: 'Herstellung von technischen Textilien', code: '13.96' },
			{ id: '13.99', name: 'Herstellung von sonstigen Textilwaren a. n. g.', code: '13.99' },
			{ id: '14', name: 'Herstellung von Bekleidung', code: '14' },
			{ id: '14.1', name: 'Herstellung von Bekleidung aus gewirktem und gestricktem Stoff', code: '14.1' },
			{ id: '14.10', name: 'Herstellung von Bekleidung aus gewirktem und gestricktem Stoff', code: '14.10' },
			{ id: '14.2', name: 'Herstellung von sonstiger Bekleidung und Bekleidungszubehör', code: '14.2' },
			{ id: '14.21', name: 'Herstellung von Oberbekleidung', code: '14.21' },
			{ id: '14.22', name: 'Herstellung von Wäsche', code: '14.22' },
			{ id: '14.23', name: 'Herstellung von Arbeits- und Berufsbekleidung', code: '14.23' },
			{ id: '14.24', name: 'Herstellung von Lederbekleidung und Pelzwaren', code: '14.24' },
			{
				id: '14.29',
				name: 'Herstellung von sonstiger Bekleidung und Bekleidungszubehör a. n. g.',
				code: '14.29',
			},
			{
				id: '15',
				name: 'Herstellung von Leder, Lederwaren und ähnlichen Produkten aus anderen Materialen',
				code: '15',
			},
			{
				id: '15.1',
				name: 'Gerben, Färben, Zurichten von Leder und Fellen; Herstellung von Reisegepäck, Handtaschen, Sattlerwaren und Geschirren',
				code: '15.1',
			},
			{ id: '15.11', name: 'Gerben, Färben, Zurichten von Leder und Fellen', code: '15.11' },
			{
				id: '15.12',
				name: 'Herstellung von Reisegepäck, Handtaschen, Sattlerwaren und Geschirren aus Stoffen aller Art',
				code: '15.12',
			},
			{ id: '15.2', name: 'Herstellung von Schuhen', code: '15.2' },
			{ id: '15.20', name: 'Herstellung von Schuhen', code: '15.20' },
			{ id: '16', name: 'Herstellung von Holz-, Flecht-, Korb- und Korkwaren, ohne Möbel', code: '16' },
			{ id: '16.1', name: 'Säge- und Hobelwerke; Bearbeitung und Veredlung von Holz', code: '16.1' },
			{ id: '16.11', name: 'Säge- und Hobelwerke', code: '16.11' },
			{ id: '16.12', name: 'Bearbeitung und Veredlung von Holz', code: '16.12' },
			{ id: '16.2', name: 'Herstellung von sonstigen Holz-, Kork-, Flecht- und Korbwaren', code: '16.2' },
			{
				id: '16.21',
				name: 'Herstellung von Furnier-, Sperrholz-, Holzfaser- und Holzspanplatten',
				code: '16.21',
			},
			{ id: '16.22', name: 'Herstellung von Parketttafeln', code: '16.22' },
			{
				id: '16.23',
				name: 'Herstellung von sonstigen Konstruktionsteilen, Fertigbauteilen, Ausbauelementen und Fertigteilbauten aus Holz',
				code: '16.23',
			},
			{
				id: '16.24',
				name: 'Herstellung von Verpackungsmitteln, Lagerbehältern und Ladungsträgern aus Holz',
				code: '16.24',
			},
			{ id: '16.25', name: 'Herstellung von Türen und Fenstern aus Holz', code: '16.25' },
			{ id: '16.26', name: 'Herstellung von festen Brennstoffen aus pflanzlicher Biomasse', code: '16.26' },
			{ id: '16.27', name: 'Veredlung von Holzwaren', code: '16.27' },
			{
				id: '16.28',
				name: 'Herstellung von sonstigen Holzwaren sowie Kork-, Flecht- und Korbwaren',
				code: '16.28',
			},
			{ id: '17', name: 'Herstellung von Papier, Pappe und Waren daraus', code: '17' },
			{ id: '17.1', name: 'Herstellung von Holz- und Zellstoff, Papier, Karton und Pappe', code: '17.1' },
			{ id: '17.11', name: 'Herstellung von Holz- und Zellstoff', code: '17.11' },
			{ id: '17.12', name: 'Herstellung von Papier, Karton und Pappe', code: '17.12' },
			{ id: '17.2', name: 'Herstellung von Waren aus Papier, Karton und Pappe', code: '17.2' },
			{
				id: '17.21',
				name: 'Herstellung von Wellpapier und -pappe sowie von Verpackungsmitteln aus Papier, Karton und Pappe',
				code: '17.21',
			},
			{
				id: '17.22',
				name: 'Herstellung von Haushalts-, Hygiene- und Toilettenartikeln aus Zellstoff, Papier und Pappe',
				code: '17.22',
			},
			{
				id: '17.23',
				name: 'Herstellung von Schreibwaren und Bürobedarf aus Papier, Karton und Pappe',
				code: '17.23',
			},
			{ id: '17.24', name: 'Herstellung von Tapeten', code: '17.24' },
			{ id: '17.25', name: 'Herstellung von sonstigen Waren aus Papier, Karton und Pappe', code: '17.25' },
			{
				id: '18',
				name: 'Herstellung von Druckerzeugnissen; Vervielfältigung von bespielten Ton-, Bild- und Datenträgern',
				code: '18',
			},
			{ id: '18.1', name: 'Herstellung von Druckerzeugnissen', code: '18.1' },
			{ id: '18.11', name: 'Drucken von Zeitungen', code: '18.11' },
			{ id: '18.12', name: 'Sonstiges Drucken', code: '18.12' },
			{ id: '18.13', name: 'Druck- und Medienvorstufe', code: '18.13' },
			{ id: '18.14', name: 'Binden von Druckerzeugnissen und damit verbundene Dienstleistungen', code: '18.14' },
			{ id: '18.2', name: 'Vervielfältigung von bespielten Ton-, Bild- und Datenträgern', code: '18.2' },
			{ id: '18.20', name: 'Vervielfältigung von bespielten Ton-, Bild- und Datenträgern', code: '18.20' },
			{ id: '19', name: 'Kokerei und Mineralölverarbeitung', code: '19' },
			{ id: '19.1', name: 'Kokerei', code: '19.1' },
			{ id: '19.10', name: 'Kokerei', code: '19.10' },
			{ id: '19.2', name: 'Herstellung von Mineralölerzeugnissen und von fossilen Brennstoffen', code: '19.2' },
			{ id: '19.20', name: 'Herstellung von Mineralölerzeugnissen und von fossilen Brennstoffen', code: '19.20' },
			{ id: '20', name: 'Herstellung von chemischen Erzeugnissen', code: '20' },
			{
				id: '20.1',
				name: 'Herstellung von chemischen Grundstoffen, Düngemitteln und Stickstoffverbindungen, Kunststoffen in Primärformen und synthetischem Kautschuk in Primärformen',
				code: '20.1',
			},
			{ id: '20.11', name: 'Herstellung von Industriegasen', code: '20.11' },
			{ id: '20.12', name: 'Herstellung von Farbstoffen und Pigmenten', code: '20.12' },
			{
				id: '20.13',
				name: 'Herstellung von sonstigen anorganischen Grundstoffen und Chemikalien',
				code: '20.13',
			},
			{ id: '20.14', name: 'Herstellung von sonstigen organischen Grundstoffen und Chemikalien', code: '20.14' },
			{ id: '20.15', name: 'Herstellung von Düngemitteln und Stickstoffverbindungen', code: '20.15' },
			{ id: '20.16', name: 'Herstellung von Kunststoffen in Primärformen', code: '20.16' },
			{ id: '20.17', name: 'Herstellung von synthetischem Kautschuk in Primärformen', code: '20.17' },
			{
				id: '20.2',
				name: 'Herstellung von Schädlingsbekämpfungs-, Pflanzenschutz- und Desinfektionsmitteln',
				code: '20.2',
			},
			{
				id: '20.20',
				name: 'Herstellung von Schädlingsbekämpfungs-, Pflanzenschutz- und Desinfektionsmitteln',
				code: '20.20',
			},
			{ id: '20.3', name: 'Herstellung von Anstrichmitteln, Druckfarben und Kitten', code: '20.3' },
			{ id: '20.30', name: 'Herstellung von Anstrichmitteln, Druckfarben und Kitten', code: '20.30' },
			{ id: '20.4', name: 'Herstellung von Wasch-, Reinigungs- und Poliermitteln', code: '20.4' },
			{ id: '20.41', name: 'Herstellung von Seifen, Wasch-, Reinigungs- und Poliermitteln', code: '20.41' },
			{ id: '20.42', name: 'Herstellung von Körperpflegemitteln und Duftstoffen', code: '20.42' },
			{ id: '20.5', name: 'Herstellung von sonstigen chemischen Erzeugnissen', code: '20.5' },
			{ id: '20.51', name: 'Herstellung von flüssigen Biokraftstoffen', code: '20.51' },
			{ id: '20.59', name: 'Herstellung von sonstigen chemischen Erzeugnissen a. n. g.', code: '20.59' },
			{ id: '20.6', name: 'Herstellung von Chemiefasern', code: '20.6' },
			{ id: '20.60', name: 'Herstellung von Chemiefasern', code: '20.60' },
			{ id: '21', name: 'Herstellung von pharmazeutischen Erzeugnissen', code: '21' },
			{ id: '21.1', name: 'Herstellung von pharmazeutischen Grundstoffen', code: '21.1' },
			{ id: '21.10', name: 'Herstellung von pharmazeutischen Grundstoffen', code: '21.10' },
			{
				id: '21.2',
				name: 'Herstellung von pharmazeutischen Spezialitäten und sonstigen pharmazeutischen Erzeugnissen',
				code: '21.2',
			},
			{
				id: '21.20',
				name: 'Herstellung von pharmazeutischen Spezialitäten und sonstigen pharmazeutischen Erzeugnissen',
				code: '21.20',
			},
			{ id: '22', name: 'Herstellung von Gummi- und Kunststoffwaren', code: '22' },
			{ id: '22.1', name: 'Herstellung von Gummiwaren', code: '22.1' },
			{ id: '22.11', name: 'Herstellung und Runderneuerung von Bereifungen', code: '22.11' },
			{ id: '22.12', name: 'Herstellung von sonstigen Gummiwaren', code: '22.12' },
			{ id: '22.2', name: 'Herstellung von Kunststoffwaren', code: '22.2' },
			{
				id: '22.21',
				name: 'Herstellung von Platten, Folien, Schläuchen und Profilen aus Kunststoffen',
				code: '22.21',
			},
			{ id: '22.22', name: 'Herstellung von Verpackungsmitteln aus Kunststoffen', code: '22.22' },
			{ id: '22.23', name: 'Herstellung von Türen und Fenstern aus Kunststoffen', code: '22.23' },
			{ id: '22.24', name: 'Herstellung von Baubedarfsartikeln aus Kunststoffen', code: '22.24' },
			{ id: '22.25', name: 'Bearbeitung und Veredlung von Kunststoffwaren', code: '22.25' },
			{ id: '22.26', name: 'Herstellung von sonstigen Kunststoffwaren', code: '22.26' },
			{
				id: '23',
				name: 'Herstellung von Glas und Glaswaren, Keramik, Verarbeitung von Steinen und Erden',
				code: '23',
			},
			{ id: '23.1', name: 'Herstellung von Glas und Glaswaren', code: '23.1' },
			{ id: '23.11', name: 'Herstellung von Flachglas', code: '23.11' },
			{ id: '23.12', name: 'Veredlung und Bearbeitung von Flachglas', code: '23.12' },
			{ id: '23.13', name: 'Herstellung von Hohlglas', code: '23.13' },
			{ id: '23.14', name: 'Herstellung von Glasfasern und Waren daraus', code: '23.14' },
			{
				id: '23.15',
				name: 'Herstellung, Veredlung und Bearbeitung von sonstigem Glas einschließlich technischen Glaswaren',
				code: '23.15',
			},
			{ id: '23.2', name: 'Herstellung von feuerfesten keramischen Werkstoffen und Waren', code: '23.2' },
			{ id: '23.20', name: 'Herstellung von feuerfesten keramischen Werkstoffen und Waren', code: '23.20' },
			{ id: '23.3', name: 'Herstellung von keramischen Baumaterialien', code: '23.3' },
			{ id: '23.31', name: 'Herstellung von keramischen Wand- und Bodenfliesen und -platten', code: '23.31' },
			{ id: '23.32', name: 'Herstellung von Ziegeln und sonstiger Baukeramik', code: '23.32' },
			{ id: '23.4', name: 'Herstellung von sonstigen Porzellan- und keramischen Erzeugnissen', code: '23.4' },
			{ id: '23.41', name: 'Herstellung von keramischen Haushaltswaren und Ziergegenständen', code: '23.41' },
			{ id: '23.42', name: 'Herstellung von Sanitärkeramik', code: '23.42' },
			{ id: '23.43', name: 'Herstellung von Isolatoren und Isolierteilen aus Keramik', code: '23.43' },
			{
				id: '23.44',
				name: 'Herstellung von keramischen Erzeugnissen für sonstige technische Zwecke',
				code: '23.44',
			},
			{ id: '23.45', name: 'Herstellung von sonstigen keramischen Erzeugnissen', code: '23.45' },
			{ id: '23.5', name: 'Herstellung von Zement, Kalk und gebranntem Gips', code: '23.5' },
			{ id: '23.51', name: 'Herstellung von Zement', code: '23.51' },
			{ id: '23.52', name: 'Herstellung von Kalk und gebranntem Gips', code: '23.52' },
			{ id: '23.6', name: 'Herstellung von Erzeugnissen aus Beton, Zement und Gips', code: '23.6' },
			{
				id: '23.61',
				name: 'Herstellung von Erzeugnissen aus Beton, Zement und Kalksandstein für den Bau',
				code: '23.61',
			},
			{ id: '23.62', name: 'Herstellung von Gipserzeugnissen für den Bau', code: '23.62' },
			{ id: '23.63', name: 'Herstellung von Frischbeton, Transportbeton', code: '23.63' },
			{ id: '23.64', name: 'Herstellung von Mörtel und sonstigem Beton, ohne Frischbeton', code: '23.64' },
			{ id: '23.65', name: 'Herstellung von Faserzementwaren', code: '23.65' },
			{ id: '23.66', name: 'Herstellung von sonstigen Erzeugnissen aus Beton, Zement und Gips', code: '23.66' },
			{ id: '23.7', name: 'Be- und Verarbeitung von Naturwerksteinen und Natursteinen', code: '23.7' },
			{ id: '23.70', name: 'Be- und Verarbeitung von Naturwerksteinen und Natursteinen', code: '23.70' },
			{
				id: '23.9',
				name: 'Herstellung von Schleifkörpern und Schleifmitteln auf Unterlage sowie sonstigen Erzeugnissen aus nichtmetallischen Mineralien a. n. g.',
				code: '23.9',
			},
			{ id: '23.91', name: 'Herstellung von Schleifkörpern und Schleifmitteln auf Unterlage', code: '23.91' },
			{
				id: '23.99',
				name: 'Herstellung von sonstigen Erzeugnissen aus nichtmetallischen Mineralien a. n. g.',
				code: '23.99',
			},
			{ id: '24', name: 'Metallerzeugung und -bearbeitung', code: '24' },
			{ id: '24.1', name: 'Erzeugung von Roheisen, Stahl und Ferrolegierungen', code: '24.1' },
			{ id: '24.10', name: 'Erzeugung von Roheisen, Stahl und Ferrolegierungen', code: '24.10' },
			{
				id: '24.2',
				name: 'Herstellung von Stahlrohren, Rohrform-, Rohrverschluss- und Rohrverbindungsstücken aus Stahl',
				code: '24.2',
			},
			{
				id: '24.20',
				name: 'Herstellung von Stahlrohren, Rohrform-, Rohrverschluss- und Rohrverbindungsstücken aus Stahl',
				code: '24.20',
			},
			{ id: '24.3', name: 'Sonstige erste Bearbeitung von Eisen und Stahl', code: '24.3' },
			{ id: '24.31', name: 'Herstellung von Blankstahl', code: '24.31' },
			{ id: '24.32', name: 'Herstellung von Kaltband mit einer Breite von weniger als 600 mm', code: '24.32' },
			{ id: '24.33', name: 'Herstellung von Kaltprofilen', code: '24.33' },
			{ id: '24.34', name: 'Herstellung von kaltgezogenem Draht', code: '24.34' },
			{ id: '24.4', name: 'Erzeugung und erste Bearbeitung von NE-Metallen', code: '24.4' },
			{ id: '24.41', name: 'Erzeugung und erste Bearbeitung von Edelmetallen', code: '24.41' },
			{ id: '24.42', name: 'Erzeugung und erste Bearbeitung von Aluminium', code: '24.42' },
			{ id: '24.43', name: 'Erzeugung und erste Bearbeitung von Blei, Zink und Zinn', code: '24.43' },
			{ id: '24.44', name: 'Erzeugung und erste Bearbeitung von Kupfer', code: '24.44' },
			{ id: '24.45', name: 'Erzeugung und erste Bearbeitung von sonstigen NE-Metallen', code: '24.45' },
			{ id: '24.46', name: 'Aufbereitung von Kernbrennstoffen', code: '24.46' },
			{ id: '24.5', name: 'Gießereien', code: '24.5' },
			{ id: '24.51', name: 'Eisengießereien', code: '24.51' },
			{ id: '24.52', name: 'Stahlgießereien', code: '24.52' },
			{ id: '24.53', name: 'Leichtmetallgießereien', code: '24.53' },
			{ id: '24.54', name: 'Buntmetallgießereien', code: '24.54' },
			{ id: '25', name: 'Herstellung von Metallerzeugnissen', code: '25' },
			{ id: '25.1', name: 'Stahl- und Leichtmetallbau', code: '25.1' },
			{ id: '25.11', name: 'Herstellung von Metallkonstruktionen', code: '25.11' },
			{ id: '25.12', name: 'Herstellung von Ausbauelementen aus Metall', code: '25.12' },
			{ id: '25.2', name: 'Herstellung von Metalltanks und -behältern', code: '25.2' },
			{
				id: '25.21',
				name: 'Herstellung von Heizkörpern, Dampfkesseln und Kesseln zum Erzeugen von überhitztem Wasser',
				code: '25.21',
			},
			{ id: '25.22', name: 'Herstellung von Sammelbehältern, Tanks u. ä. Behältern aus Metall', code: '25.22' },
			{ id: '25.3', name: 'Herstellung von Waffen und Munition', code: '25.3' },
			{ id: '25.30', name: 'Herstellung von Waffen und Munition', code: '25.30' },
			{
				id: '25.4',
				name: 'Herstellung von Schmiede-, Press-, Zieh- und Stanzteilen und pulvermetallurgischen Erzeugnissen',
				code: '25.4',
			},
			{
				id: '25.40',
				name: 'Herstellung von Schmiede-, Press-, Zieh- und Stanzteilen und pulvermetallurgischen Erzeugnissen',
				code: '25.40',
			},
			{ id: '25.5', name: 'Oberflächenveredlung und Wärmebehandlung; Metallbearbeitung a. n. g.', code: '25.5' },
			{ id: '25.51', name: 'Beschichten von Metallen', code: '25.51' },
			{ id: '25.52', name: 'Wärmebehandlung von Metallen', code: '25.52' },
			{ id: '25.53', name: 'Metallbearbeitung a. n. g.', code: '25.53' },
			{
				id: '25.6',
				name: 'Herstellung von Schneidwaren, Werkzeugen, Schlössern und Beschlägen aus unedlen Metallen',
				code: '25.6',
			},
			{ id: '25.61', name: 'Herstellung von Schneidwaren und Bestecken aus unedlen Metallen', code: '25.61' },
			{ id: '25.62', name: 'Herstellung von Schlössern und Beschlägen aus unedlen Metallen', code: '25.62' },
			{ id: '25.63', name: 'Herstellung von Werkzeugen', code: '25.63' },
			{ id: '25.9', name: 'Herstellung von sonstigen Metallwaren', code: '25.9' },
			{
				id: '25.91',
				name: 'Herstellung von Fässern, Trommeln, Dosen, Eimern u. ä. Behältern aus Metall',
				code: '25.91',
			},
			{
				id: '25.92',
				name: 'Herstellung von Verpackungen und Verschlüssen aus Eisen, Stahl und NE-Metall',
				code: '25.92',
			},
			{ id: '25.93', name: 'Herstellung von Drahtwaren, Ketten und Federn', code: '25.93' },
			{ id: '25.94', name: 'Herstellung von Schrauben und Nieten', code: '25.94' },
			{ id: '25.99', name: 'Herstellung von sonstigen Metallwaren a. n. g.', code: '25.99' },
			{
				id: '26',
				name: 'Herstellung von Datenverarbeitungsgeräten, elektronischen und optischen Erzeugnissen',
				code: '26',
			},
			{ id: '26.1', name: 'Herstellung von elektronischen Bauelementen und Leiterplatten', code: '26.1' },
			{ id: '26.11', name: 'Herstellung von elektronischen Bauelementen', code: '26.11' },
			{ id: '26.12', name: 'Herstellung von bestückten Leiterplatten', code: '26.12' },
			{ id: '26.2', name: 'Herstellung von Datenverarbeitungsgeräten und peripheren Geräten', code: '26.2' },
			{ id: '26.20', name: 'Herstellung von Datenverarbeitungsgeräten und peripheren Geräten', code: '26.20' },
			{
				id: '26.3',
				name: 'Herstellung von Geräten und Einrichtungen der Telekommunikationstechnik',
				code: '26.3',
			},
			{
				id: '26.30',
				name: 'Herstellung von Geräten und Einrichtungen der Telekommunikationstechnik',
				code: '26.30',
			},
			{ id: '26.4', name: 'Herstellung von Geräten der Unterhaltungselektronik', code: '26.4' },
			{ id: '26.40', name: 'Herstellung von Geräten der Unterhaltungselektronik', code: '26.40' },
			{ id: '26.5', name: 'Herstellung von Mess- und Kontrollinstrumenten sowie von Uhren', code: '26.5' },
			{
				id: '26.51',
				name: 'Herstellung von Mess-, Kontroll-, Navigations- u. ä. Instrumenten und Vorrichtungen',
				code: '26.51',
			},
			{ id: '26.52', name: 'Herstellung von Uhren', code: '26.52' },
			{
				id: '26.6',
				name: 'Herstellung von Bestrahlungs- und Elektrotherapiegeräten und elektromedizinischen Geräten',
				code: '26.6',
			},
			{
				id: '26.60',
				name: 'Herstellung von Bestrahlungs- und Elektrotherapiegeräten und elektromedizinischen Geräten',
				code: '26.60',
			},
			{
				id: '26.7',
				name: 'Herstellung von optischen und fotografischen Instrumenten und Geräten sowie von magnetischen und optischen Datenträgern',
				code: '26.7',
			},
			{
				id: '26.70',
				name: 'Herstellung von optischen und fotografischen Instrumenten und Geräten sowie von magnetischen und optischen Datenträgern',
				code: '26.70',
			},
			{ id: '27', name: 'Herstellung von elektrischen Ausrüstungen', code: '27' },
			{
				id: '27.1',
				name: 'Herstellung von Elektromotoren, Generatoren, Transformatoren, Elektrizitätsverteilungs- und -schalteinrichtungen',
				code: '27.1',
			},
			{ id: '27.11', name: 'Herstellung von Elektromotoren, Generatoren und Transformatoren', code: '27.11' },
			{ id: '27.12', name: 'Herstellung von Elektrizitätsverteilungs- und -schalteinrichtungen', code: '27.12' },
			{ id: '27.2', name: 'Herstellung von Batterien und Akkumulatoren', code: '27.2' },
			{ id: '27.20', name: 'Herstellung von Batterien und Akkumulatoren', code: '27.20' },
			{ id: '27.3', name: 'Herstellung von Kabeln und elektrischem Installationsmaterial', code: '27.3' },
			{ id: '27.31', name: 'Herstellung von Glasfaserkabeln', code: '27.31' },
			{
				id: '27.32',
				name: 'Herstellung von sonstigen elektronischen und elektrischen Drähten und Kabeln',
				code: '27.32',
			},
			{ id: '27.33', name: 'Herstellung von elektrischem Installationsmaterial', code: '27.33' },
			{ id: '27.4', name: 'Herstellung von Lampen und Leuchten', code: '27.4' },
			{ id: '27.40', name: 'Herstellung von Lampen und Leuchten', code: '27.40' },
			{ id: '27.5', name: 'Herstellung von Haushaltsgeräten', code: '27.5' },
			{ id: '27.51', name: 'Herstellung von elektrischen Haushaltsgeräten', code: '27.51' },
			{ id: '27.52', name: 'Herstellung von nichtelektrischen Haushaltsgeräten', code: '27.52' },
			{ id: '27.9', name: 'Herstellung von sonstigen elektrischen Ausrüstungen und Geräten', code: '27.9' },
			{ id: '27.90', name: 'Herstellung von sonstigen elektrischen Ausrüstungen und Geräten', code: '27.90' },
			{ id: '28', name: 'Maschinenbau', code: '28' },
			{ id: '28.1', name: 'Herstellung von nicht wirtschaftszweigspezifischen Maschinen', code: '28.1' },
			{
				id: '28.11',
				name: 'Herstellung von Verbrennungsmotoren und Turbinen, ohne Motoren für Luft- und Straßenfahrzeuge',
				code: '28.11',
			},
			{
				id: '28.12',
				name: 'Herstellung von hydraulischen und pneumatischen Komponenten und Systemen',
				code: '28.12',
			},
			{ id: '28.13', name: 'Herstellung von sonstigen Pumpen und Kompressoren', code: '28.13' },
			{ id: '28.14', name: 'Herstellung von sonstigen Armaturen', code: '28.14' },
			{ id: '28.15', name: 'Herstellung von Lagern, Getrieben, Zahnrädern und Antriebselementen', code: '28.15' },
			{
				id: '28.2',
				name: 'Herstellung von sonstigen nicht wirtschaftszweigspezifischen Maschinen',
				code: '28.2',
			},
			{
				id: '28.21',
				name: 'Herstellung von Öfen, Brennern und ortsfesten Heizgeräten für den Haushalt',
				code: '28.21',
			},
			{ id: '28.22', name: 'Herstellung von Hebezeugen und Fördermitteln', code: '28.22' },
			{
				id: '28.23',
				name: 'Herstellung von Büromaschinen, ohne Datenverarbeitungsgeräte und periphere Geräte',
				code: '28.23',
			},
			{ id: '28.24', name: 'Herstellung von handgeführten Werkzeugen mit Motorantrieb', code: '28.24' },
			{
				id: '28.25',
				name: 'Herstellung von kälte- und lufttechnischen Erzeugnissen, nicht für den Haushalt',
				code: '28.25',
			},
			{
				id: '28.29',
				name: 'Herstellung von sonstigen nicht wirtschaftszweigspezifischen Maschinen a. n. g.',
				code: '28.29',
			},
			{ id: '28.3', name: 'Herstellung von land- und forstwirtschaftlichen Maschinen', code: '28.3' },
			{ id: '28.30', name: 'Herstellung von land- und forstwirtschaftlichen Maschinen', code: '28.30' },
			{ id: '28.4', name: 'Herstellung von Werkzeugmaschinen', code: '28.4' },
			{ id: '28.41', name: 'Herstellung von Werkzeugmaschinen für die Metallbearbeitung', code: '28.41' },
			{ id: '28.42', name: 'Herstellung von sonstigen Werkzeugmaschinen', code: '28.42' },
			{ id: '28.9', name: 'Herstellung von Maschinen für sonstige bestimmte Wirtschaftszweige', code: '28.9' },
			{
				id: '28.91',
				name: 'Herstellung von Maschinen für die Metallerzeugung, von Walzwerkseinrichtungen und Gießmaschinen',
				code: '28.91',
			},
			{ id: '28.92', name: 'Herstellung von Bergwerks-, Bau- und Baustoffmaschinen', code: '28.92' },
			{
				id: '28.93',
				name: 'Herstellung von Maschinen für die Nahrungs- und Genussmittelerzeugung und die Tabakverarbeitung',
				code: '28.93',
			},
			{
				id: '28.94',
				name: 'Herstellung von Maschinen für die Textil- und Bekleidungsherstellung und die Lederverarbeitung',
				code: '28.94',
			},
			{ id: '28.95', name: 'Herstellung von Maschinen für die Papiererzeugung und -verarbeitung', code: '28.95' },
			{
				id: '28.96',
				name: 'Herstellung von Maschinen für die Verarbeitung von Kunststoffen und Kautschuk',
				code: '28.96',
			},
			{ id: '28.97', name: 'Herstellung von Maschinen für die additive Fertigung', code: '28.97' },
			{
				id: '28.99',
				name: 'Herstellung von Maschinen für sonstige bestimmte Wirtschaftszweige a. n. g.',
				code: '28.99',
			},
			{ id: '29', name: 'Herstellung von Kraftwagen und Kraftwagenteilen', code: '29' },
			{ id: '29.1', name: 'Herstellung von Kraftwagen und Kraftwagenmotoren', code: '29.1' },
			{ id: '29.10', name: 'Herstellung von Kraftwagen und Kraftwagenmotoren', code: '29.10' },
			{ id: '29.2', name: 'Herstellung von Karosserien, Aufbauten und Anhängern', code: '29.2' },
			{ id: '29.20', name: 'Herstellung von Karosserien, Aufbauten und Anhängern', code: '29.20' },
			{ id: '29.3', name: 'Herstellung von Teilen und Zubehör für Kraftwagen', code: '29.3' },
			{
				id: '29.31',
				name: 'Herstellung elektrischer und elektronischer Ausrüstungsgegenstände für Kraftwagen',
				code: '29.31',
			},
			{
				id: '29.32',
				name: 'Herstellung von sonstigen Teilen und sonstigem Zubehör für Kraftwagen',
				code: '29.32',
			},
			{ id: '30', name: 'Sonstiger Fahrzeugbau', code: '30' },
			{ id: '30.1', name: 'Schiff- und Bootsbau', code: '30.1' },
			{
				id: '30.11',
				name: 'Bau von Schiffen und schwimmenden Vorrichtungen für zivile Zwecke, ohne Boots- und Yachtbau',
				code: '30.11',
			},
			{ id: '30.12', name: 'Boots- und Yachtbau', code: '30.12' },
			{ id: '30.13', name: 'Bau von Kriegsschiffen', code: '30.13' },
			{ id: '30.2', name: 'Schienenfahrzeugbau', code: '30.2' },
			{ id: '30.20', name: 'Schienenfahrzeugbau', code: '30.20' },
			{ id: '30.3', name: 'Luft- und Raumfahrzeugbau', code: '30.3' },
			{ id: '30.31', name: 'Luft- und Raumfahrzeugbau für zivile Zwecke', code: '30.31' },
			{ id: '30.32', name: 'Luft- und Raumfahrzeugbau für militärische Zwecke', code: '30.32' },
			{ id: '30.4', name: 'Herstellung von militärischen Kampffahrzeugen', code: '30.4' },
			{ id: '30.40', name: 'Herstellung von militärischen Kampffahrzeugen', code: '30.40' },
			{ id: '30.9', name: 'Herstellung von Beförderungsmitteln a. n. g.', code: '30.9' },
			{ id: '30.91', name: 'Herstellung von Krafträdern', code: '30.91' },
			{ id: '30.92', name: 'Herstellung von Fahrrädern sowie von Behindertenfahrzeugen', code: '30.92' },
			{ id: '30.99', name: 'Herstellung von sonstigen Beförderungsmitteln a. n. g.', code: '30.99' },
			{ id: '31', name: 'Herstellung von Möbeln', code: '31' },
			{ id: '31.0', name: 'Herstellung von Möbeln', code: '31.0' },
			{ id: '31.00', name: 'Herstellung von Möbeln', code: '31.00' },
			{ id: '32', name: 'Herstellung von sonstigen Waren', code: '32' },
			{ id: '32.1', name: 'Herstellung von Münzen, Schmuck und ähnlichen Erzeugnissen', code: '32.1' },
			{ id: '32.11', name: 'Herstellung von Münzen', code: '32.11' },
			{
				id: '32.12',
				name: 'Herstellung von Schmuck, Gold- und Silberschmiedewaren, ohne Fantasieschmuck',
				code: '32.12',
			},
			{ id: '32.13', name: 'Herstellung von Fantasieschmuck', code: '32.13' },
			{ id: '32.2', name: 'Herstellung von Musikinstrumenten', code: '32.2' },
			{ id: '32.20', name: 'Herstellung von Musikinstrumenten', code: '32.20' },
			{ id: '32.3', name: 'Herstellung von Sportgeräten', code: '32.3' },
			{ id: '32.30', name: 'Herstellung von Sportgeräten', code: '32.30' },
			{ id: '32.4', name: 'Herstellung von Spielwaren', code: '32.4' },
			{ id: '32.40', name: 'Herstellung von Spielwaren', code: '32.40' },
			{
				id: '32.5',
				name: 'Herstellung von medizinischen und zahnmedizinischen Apparaten und Materialien',
				code: '32.5',
			},
			{
				id: '32.50',
				name: 'Herstellung von medizinischen und zahnmedizinischen Apparaten und Materialien',
				code: '32.50',
			},
			{ id: '32.9', name: 'Herstellung von Erzeugnissen a. n. g.', code: '32.9' },
			{ id: '32.91', name: 'Herstellung von Besen und Bürsten', code: '32.91' },
			{ id: '32.99', name: 'Herstellung von sonstigen Erzeugnissen a. n. g.', code: '32.99' },
			{ id: '33', name: 'Reparatur, Instandhaltung und Installation von Maschinen und Ausrüstungen', code: '33' },
			{
				id: '33.1',
				name: 'Reparatur und Instandhaltung von Metallerzeugnissen, Maschinen und Ausrüstungen',
				code: '33.1',
			},
			{ id: '33.11', name: 'Reparatur und Instandhaltung von Metallerzeugnissen', code: '33.11' },
			{ id: '33.12', name: 'Reparatur und Instandhaltung von Maschinen', code: '33.12' },
			{
				id: '33.13',
				name: 'Reparatur und Instandhaltung von elektronischen und optischen Geräten',
				code: '33.13',
			},
			{ id: '33.14', name: 'Reparatur und Instandhaltung von elektrischen Ausrüstungen', code: '33.14' },
			{
				id: '33.15',
				name: 'Reparatur und Instandhaltung von zivilen Schiffen, Booten und Yachten',
				code: '33.15',
			},
			{ id: '33.16', name: 'Reparatur und Instandhaltung von zivilen Luft- und Raumfahrzeugen', code: '33.16' },
			{
				id: '33.17',
				name: 'Reparatur und Instandhaltung von sonstigen zivilen Beförderungsmitteln',
				code: '33.17',
			},
			{
				id: '33.18',
				name: 'Reparatur und Instandhaltung von militärischen Kampffahrzeugen, Luft- und Raumfahrzeugen sowie Kriegsschiffen',
				code: '33.18',
			},
			{ id: '33.19', name: 'Reparatur und Instandhaltung von sonstigen Ausrüstungen', code: '33.19' },
			{ id: '33.2', name: 'Installation von Industriemaschinen und -ausrüstungen', code: '33.2' },
			{ id: '33.20', name: 'Installation von Industriemaschinen und -ausrüstungen', code: '33.20' },
		],
	},
	{
		id: 'D',
		name: 'Energieversorgung',
		code: '35',
		subcategories: [
			{ id: '35', name: 'Energieversorgung', code: '35' },
			{ id: '35.1', name: 'Elektrizitätsversorgung', code: '35.1' },
			{ id: '35.11', name: 'Elektrizitätserzeugung aus nicht erneuerbaren Energieträgern', code: '35.11' },
			{ id: '35.12', name: 'Elektrizitätserzeugung aus erneuerbaren Energieträgern', code: '35.12' },
			{ id: '35.13', name: 'Elektrizitätsübertragung', code: '35.13' },
			{ id: '35.14', name: 'Elektrizitätsverteilung', code: '35.14' },
			{ id: '35.15', name: 'Elektrizitätshandel', code: '35.15' },
			{ id: '35.16', name: 'Speichern von elektrischer Energie', code: '35.16' },
			{ id: '35.2', name: 'Gasversorgung', code: '35.2' },
			{ id: '35.21', name: 'Gaserzeugung', code: '35.21' },
			{ id: '35.22', name: 'Gasverteilung durch Rohrleitungen', code: '35.22' },
			{ id: '35.23', name: 'Gashandel durch Rohrleitungen', code: '35.23' },
			{ id: '35.24', name: 'Speichern von Gas zu Versorgungszwecken', code: '35.24' },
			{ id: '35.3', name: 'Wärme- und Kälteversorgung', code: '35.3' },
			{ id: '35.30', name: 'Wärme- und Kälteversorgung', code: '35.30' },
			{ id: '35.4', name: 'Tätigkeiten von Strom- und Erdgasmaklerinnen und -maklern', code: '35.4' },
			{ id: '35.40', name: 'Tätigkeiten von Strom- und Erdgasmaklerinnen und -maklern', code: '35.40' },
		],
	},
	{
		id: 'E',
		name: 'Abwasser- und Abfallentsorgung und Beseitigung von Umweltverschmutzungen',
		code: '36-39',
		subcategories: [
			{ id: '36', name: 'Wasserversorgung', code: '36' },
			{ id: '36.0', name: 'Wasserversorgung', code: '36.0' },
			{ id: '36.00', name: 'Wasserversorgung', code: '36.00' },
			{ id: '37', name: 'Abwasserentsorgung', code: '37' },
			{ id: '37.0', name: 'Abwasserentsorgung', code: '37.0' },
			{ id: '37.00', name: 'Abwasserentsorgung', code: '37.00' },
			{ id: '38', name: 'Sammlung, Verwertung und Beseitigung von Abfällen', code: '38' },
			{ id: '38.1', name: 'Sammlung von Abfällen', code: '38.1' },
			{ id: '38.11', name: 'Sammlung nicht gefährlicher Abfälle', code: '38.11' },
			{ id: '38.12', name: 'Sammlung gefährlicher Abfälle', code: '38.12' },
			{ id: '38.2', name: 'Verwertung von Abfällen', code: '38.2' },
			{ id: '38.21', name: 'Verwertung von Werkstoffen', code: '38.21' },
			{ id: '38.22', name: 'Energetische Verwertung von Abfällen', code: '38.22' },
			{ id: '38.23', name: 'Sonstige Verwertung von Abfällen', code: '38.23' },
			{ id: '38.3', name: 'Abfallbeseitigung ohne Verwertung', code: '38.3' },
			{ id: '38.31', name: 'Verbrennung von Abfällen ohne energetische Verwertung', code: '38.31' },
			{ id: '38.32', name: 'Deponierung oder Dauerlagerung von Abfällen', code: '38.32' },
			{ id: '38.33', name: 'Sonstige Beseitigung von Abfällen', code: '38.33' },
			{
				id: '39',
				name: 'Beseitigung von Umweltverschmutzungen und sonstige Tätigkeiten in der Abfallbewirtschaftung',
				code: '39',
			},
			{
				id: '39.0',
				name: 'Beseitigung von Umweltverschmutzungen und sonstige Tätigkeiten in der Abfallbewirtschaftung',
				code: '39.0',
			},
			{
				id: '39.00',
				name: 'Beseitigung von Umweltverschmutzungen und sonstige Tätigkeiten in der Abfallbewirtschaftung',
				code: '39.00',
			},
		],
	},
	{
		id: 'F',
		name: 'Baugewerbe',
		code: '41-43',
		subcategories: [
			{ id: '41', name: 'Hochbau', code: '41' },
			{ id: '41.0', name: 'Hochbau', code: '41.0' },
			{ id: '41.00', name: 'Hochbau', code: '41.00' },
			{ id: '42', name: 'Tiefbau', code: '42' },
			{ id: '42.1', name: 'Bau von Straßen und Bahnverkehrsstrecken', code: '42.1' },
			{ id: '42.11', name: 'Bau von Straßen', code: '42.11' },
			{ id: '42.12', name: 'Bau von Bahnverkehrsstrecken', code: '42.12' },
			{ id: '42.13', name: 'Brücken- und Tunnelbau', code: '42.13' },
			{ id: '42.2', name: 'Bau von Versorgungseinrichtungen', code: '42.2' },
			{ id: '42.21', name: 'Rohrleitungstiefbau, Brunnenbau und Kläranlagenbau', code: '42.21' },
			{
				id: '42.22',
				name: 'Bau von Versorgungseinrichtungen für Elektrizität und Telekommunikation',
				code: '42.22',
			},
			{ id: '42.9', name: 'Sonstiger Tiefbau', code: '42.9' },
			{ id: '42.91', name: 'Wasserbau', code: '42.91' },
			{ id: '42.99', name: 'Sonstiger Tiefbau a. n. g.', code: '42.99' },
			{
				id: '43',
				name: 'Vorbereitende Baustellenarbeiten, Bauinstallation und sonstiges Ausbaugewerbe',
				code: '43',
			},
			{ id: '43.1', name: 'Abbrucharbeiten und vorbereitende Baustellenarbeiten', code: '43.1' },
			{ id: '43.11', name: 'Abbrucharbeiten', code: '43.11' },
			{ id: '43.12', name: 'Vorbereitende Baustellenarbeiten', code: '43.12' },
			{ id: '43.13', name: 'Test- und Suchbohrung', code: '43.13' },
			{ id: '43.2', name: 'Bauinstallation', code: '43.2' },
			{ id: '43.21', name: 'Elektroinstallation', code: '43.21' },
			{ id: '43.22', name: 'Gas-, Wasser-, Heizungs- sowie Lüftungs- und Klimainstallation', code: '43.22' },
			{ id: '43.23', name: 'Einbau von Isolierungen', code: '43.23' },
			{ id: '43.24', name: 'Sonstige Bauinstallation', code: '43.24' },
			{ id: '43.3', name: 'Sonstiger Ausbau', code: '43.3' },
			{ id: '43.31', name: 'Anbringen von Stuckaturen, Gipserei und Verputzerei', code: '43.31' },
			{ id: '43.32', name: 'Bautischlerei und -schlosserei', code: '43.32' },
			{ id: '43.33', name: 'Fußboden-, Fliesen- und Plattenlegerei, Tapeziererei', code: '43.33' },
			{ id: '43.34', name: 'Malerei und Glaserei', code: '43.34' },
			{ id: '43.35', name: 'Sonstiger Ausbau', code: '43.35' },
			{ id: '43.4', name: 'Spezialisierte Bautätigkeiten im Hochbau', code: '43.4' },
			{ id: '43.41', name: 'Dachdeckerei und Zimmerei', code: '43.41' },
			{ id: '43.42', name: 'Sonstige spezialisierte Bautätigkeiten im Hochbau', code: '43.42' },
			{ id: '43.5', name: 'Spezialisierte Bautätigkeiten im Tiefbau', code: '43.5' },
			{ id: '43.50', name: 'Spezialisierte Bautätigkeiten im Tiefbau', code: '43.50' },
			{ id: '43.6', name: 'Vermittlungstätigkeiten für spezialisierte Bautätigkeiten', code: '43.6' },
			{ id: '43.60', name: 'Vermittlungstätigkeiten für spezialisierte Bautätigkeiten', code: '43.60' },
			{ id: '43.9', name: 'Sonstige spezialisierte Bautätigkeiten', code: '43.9' },
			{ id: '43.91', name: 'Maurerarbeiten', code: '43.91' },
			{ id: '43.99', name: 'Sonstige spezialisierte Bautätigkeiten a. n. g.', code: '43.99' },
		],
	},
	{
		id: 'G',
		name: 'Handel',
		code: '46-47',
		subcategories: [
			{ id: '46', name: 'Großhandel', code: '46' },
			{ id: '46.1', name: 'Handelsvermittlung', code: '46.1' },
			{
				id: '46.11',
				name: 'Tätigkeiten der Großhandelsvermittlung von landwirtschaftlichen Grundstoffen, lebenden Tieren, textilen Rohstoffen und Halbwaren',
				code: '46.11',
			},
			{
				id: '46.12',
				name: 'Tätigkeiten der Großhandelsvermittlung von Brennstoffen, Erzen, Metallen und technischen Chemikalien',
				code: '46.12',
			},
			{
				id: '46.13',
				name: 'Tätigkeiten der Großhandelsvermittlung von Holz, Baustoffen und Anstrichmitteln',
				code: '46.13',
			},
			{
				id: '46.14',
				name: 'Tätigkeiten der Großhandelsvermittlung von Maschinen, technischem Bedarf, Wasser- und Luftfahrzeugen',
				code: '46.14',
			},
			{
				id: '46.15',
				name: 'Tätigkeiten der Großhandelsvermittlung von Möbeln, Einrichtungs- und Haushaltsgegenständen, Eisen- und Metallwaren',
				code: '46.15',
			},
			{
				id: '46.16',
				name: 'Tätigkeiten der Großhandelsvermittlung von Textilien, Bekleidung, Schuhen und Lederwaren',
				code: '46.16',
			},
			{
				id: '46.17',
				name: 'Tätigkeiten der Großhandelsvermittlung von Nahrungsmitteln, Getränken und Tabakwaren',
				code: '46.17',
			},
			{ id: '46.18', name: 'Tätigkeiten der Großhandelsvermittlung von sonstigen Waren', code: '46.18' },
			{
				id: '46.19',
				name: 'Tätigkeiten der Großhandelsvermittlung von Waren ohne ausgeprägten Schwerpunkt',
				code: '46.19',
			},
			{ id: '46.2', name: 'Großhandel mit landwirtschaftlichen Grundstoffen und lebenden Tieren', code: '46.2' },
			{ id: '46.21', name: 'Großhandel mit Getreide, Rohtabak, Saatgut und Futtermitteln', code: '46.21' },
			{ id: '46.22', name: 'Großhandel mit Blumen und Pflanzen', code: '46.22' },
			{ id: '46.23', name: 'Großhandel mit lebenden Tieren', code: '46.23' },
			{ id: '46.24', name: 'Großhandel mit Häuten, Fellen und Leder', code: '46.24' },
			{ id: '46.3', name: 'Großhandel mit Nahrungs- und Genussmitteln, Getränken und Tabakwaren', code: '46.3' },
			{ id: '46.31', name: 'Großhandel mit Obst, Gemüse und Kartoffeln', code: '46.31' },
			{ id: '46.32', name: 'Großhandel mit Fleisch, Fleischwaren, Fisch und Fischerzeugnissen', code: '46.32' },
			{
				id: '46.33',
				name: 'Großhandel mit Milch, Milcherzeugnissen, Eiern, Speiseölen und Nahrungsfetten',
				code: '46.33',
			},
			{ id: '46.34', name: 'Großhandel mit Getränken', code: '46.34' },
			{ id: '46.35', name: 'Großhandel mit Tabakwaren', code: '46.35' },
			{ id: '46.36', name: 'Großhandel mit Zucker, Süßwaren und Backwaren', code: '46.36' },
			{ id: '46.37', name: 'Großhandel mit Kaffee, Tee, Kakao und Gewürzen', code: '46.37' },
			{ id: '46.38', name: 'Großhandel mit sonstigen Nahrungs- und Genussmitteln', code: '46.38' },
			{
				id: '46.39',
				name: 'Großhandel mit Nahrungs- und Genussmitteln, Getränken und Tabakwaren, ohne ausgeprägten Schwerpunkt',
				code: '46.39',
			},
			{ id: '46.4', name: 'Großhandel mit Gebrauchs- und Verbrauchsgütern', code: '46.4' },
			{ id: '46.41', name: 'Großhandel mit Textilien', code: '46.41' },
			{ id: '46.42', name: 'Großhandel mit Bekleidung und Schuhen', code: '46.42' },
			{
				id: '46.43',
				name: 'Großhandel mit Foto- und optischen Erzeugnissen, elektrischen Haushaltsgeräten und Geräten der Unterhaltungselektronik',
				code: '46.43',
			},
			{
				id: '46.44',
				name: 'Großhandel mit keramischen Erzeugnissen, Glaswaren und Reinigungsmitteln',
				code: '46.44',
			},
			{ id: '46.45', name: 'Großhandel mit kosmetischen Erzeugnissen und Körperpflegemitteln', code: '46.45' },
			{
				id: '46.46',
				name: 'Großhandel mit pharmazeutischen Erzeugnissen und medizinischen Hilfsmitteln',
				code: '46.46',
			},
			{ id: '46.47', name: 'Großhandel mit Möbeln, Teppichen, Lampen und Leuchten', code: '46.47' },
			{ id: '46.48', name: 'Großhandel mit Uhren und Schmuck', code: '46.48' },
			{ id: '46.49', name: 'Großhandel mit sonstigen Gebrauchs- und Verbrauchsgütern', code: '46.49' },
			{ id: '46.5', name: 'Großhandel mit Geräten der Informations- und Kommunikationstechnik', code: '46.5' },
			{ id: '46.50', name: 'Großhandel mit Geräten der Informations- und Kommunikationstechnik', code: '46.50' },
			{ id: '46.6', name: 'Großhandel mit sonstigen Maschinen, Ausrüstungen und Zubehör', code: '46.6' },
			{ id: '46.61', name: 'Großhandel mit landwirtschaftlichen Maschinen und Geräten', code: '46.61' },
			{ id: '46.62', name: 'Großhandel mit Werkzeugmaschinen', code: '46.62' },
			{ id: '46.63', name: 'Großhandel mit Bergwerks-, Bau- und Baustoffmaschinen', code: '46.63' },
			{ id: '46.64', name: 'Großhandel mit sonstigen Maschinen und Ausrüstungen', code: '46.64' },
			{ id: '46.7', name: 'Großhandel mit Kraftwagen, Krafträdern, deren Teilen und Zubehör', code: '46.7' },
			{ id: '46.71', name: 'Großhandel mit Kraftwagen', code: '46.71' },
			{ id: '46.72', name: 'Großhandel mit Kraftwagenteilen und -zubehör', code: '46.72' },
			{ id: '46.73', name: 'Großhandel mit Krafträdern, Kraftradteilen und -zubehör', code: '46.73' },
			{ id: '46.8', name: 'Sonstiger Großhandel', code: '46.8' },
			{ id: '46.81', name: 'Großhandel mit Brennstoffen und Mineralölerzeugnissen', code: '46.81' },
			{ id: '46.82', name: 'Großhandel mit Erzen, Metallen und Metallhalbzeug', code: '46.82' },
			{
				id: '46.83',
				name: 'Großhandel mit Holz, Baustoffen, Anstrichmitteln und Sanitärausstattung',
				code: '46.83',
			},
			{
				id: '46.84',
				name: 'Großhandel mit Metall- und Kunststoffwaren für Bauzwecke sowie Installationsbedarf für Gas, Wasser und Heizung',
				code: '46.84',
			},
			{ id: '46.85', name: 'Großhandel mit chemischen Erzeugnissen', code: '46.85' },
			{ id: '46.86', name: 'Großhandel mit sonstigen Halbwaren', code: '46.86' },
			{ id: '46.87', name: 'Großhandel mit Altmaterialien und Reststoffen', code: '46.87' },
			{ id: '46.89', name: 'Sonstiger Großhandel a. n. g.', code: '46.89' },
			{ id: '46.9', name: 'Großhandel ohne ausgeprägten Schwerpunkt', code: '46.9' },
			{ id: '46.90', name: 'Großhandel ohne ausgeprägten Schwerpunkt', code: '46.90' },
			{ id: '47', name: 'Einzelhandel', code: '47' },
			{ id: '47.1', name: 'Einzelhandel mit Waren verschiedener Art', code: '47.1' },
			{
				id: '47.11',
				name: 'Einzelhandel mit Waren verschiedener Art, Hauptrichtung Nahrungs- und Genussmittel',
				code: '47.11',
			},
			{ id: '47.12', name: 'Sonstiger Einzelhandel mit Waren verschiedener Art', code: '47.12' },
			{
				id: '47.2',
				name: 'Einzelhandel mit Nahrungs- und Genussmitteln, Getränken und Tabakwaren',
				code: '47.2',
			},
			{ id: '47.21', name: 'Einzelhandel mit Obst, Gemüse und Kartoffeln', code: '47.21' },
			{ id: '47.22', name: 'Einzelhandel mit Fleisch und Fleischwaren', code: '47.22' },
			{ id: '47.23', name: 'Einzelhandel mit Fisch, Meeresfrüchten und Fischerzeugnissen', code: '47.23' },
			{ id: '47.24', name: 'Einzelhandel mit Back- und Süßwaren', code: '47.24' },
			{ id: '47.25', name: 'Einzelhandel mit Getränken', code: '47.25' },
			{ id: '47.26', name: 'Einzelhandel mit Tabakwaren', code: '47.26' },
			{ id: '47.27', name: 'Einzelhandel mit sonstigen Nahrungs- und Genussmitteln', code: '47.27' },
			{ id: '47.3', name: 'Einzelhandel mit Motorenkraftstoffen', code: '47.3' },
			{ id: '47.30', name: 'Einzelhandel mit Motorenkraftstoffen', code: '47.30' },
			{ id: '47.4', name: 'Einzelhandel mit Geräten der Informations- und Kommunikationstechnik', code: '47.4' },
			{
				id: '47.40',
				name: 'Einzelhandel mit Geräten der Informations- und Kommunikationstechnik',
				code: '47.40',
			},
			{
				id: '47.5',
				name: 'Einzelhandel mit sonstigen Haushaltsgeräten, Textilien, Heimwerker- und Einrichtungsbedarf',
				code: '47.5',
			},
			{ id: '47.51', name: 'Einzelhandel mit Textilien', code: '47.51' },
			{
				id: '47.52',
				name: 'Einzelhandel mit Metallwaren, Anstrichmitteln, Bau- und Heimwerkerbedarf',
				code: '47.52',
			},
			{ id: '47.53', name: 'Einzelhandel mit Vorhängen, Teppichen, Fußbodenbelägen und Tapeten', code: '47.53' },
			{ id: '47.54', name: 'Einzelhandel mit elektrischen Haushaltsgeräten', code: '47.54' },
			{
				id: '47.55',
				name: 'Einzelhandel mit Möbeln, Einrichtungsgegenständen und sonstigem Hausrat',
				code: '47.55',
			},
			{ id: '47.6', name: 'Einzelhandel mit Verlagsprodukten, Sportausrüstungen und Spielwaren', code: '47.6' },
			{ id: '47.61', name: 'Einzelhandel mit Büchern', code: '47.61' },
			{
				id: '47.62',
				name: 'Einzelhandel mit Zeitschriften, Zeitungen, Schreibwaren und Bürobedarf',
				code: '47.62',
			},
			{ id: '47.63', name: 'Einzelhandel mit Fahrrädern, Sport- und Campingartikeln', code: '47.63' },
			{ id: '47.64', name: 'Einzelhandel mit Spielwaren', code: '47.64' },
			{ id: '47.69', name: 'Einzelhandel mit Kunst- und Kulturerzeugnissen a. n. g.', code: '47.69' },
			{ id: '47.7', name: 'Einzelhandel mit sonstigen Gütern, ohne Kraftwagen und Krafträder', code: '47.7' },
			{ id: '47.71', name: 'Einzelhandel mit Bekleidung', code: '47.71' },
			{ id: '47.72', name: 'Einzelhandel mit Schuhen und Lederwaren', code: '47.72' },
			{ id: '47.73', name: 'Einzelhandel mit pharmazeutischen Erzeugnissen', code: '47.73' },
			{ id: '47.74', name: 'Einzelhandel mit medizinischen und orthopädischen Artikeln', code: '47.74' },
			{ id: '47.75', name: 'Einzelhandel mit kosmetischen Erzeugnissen und Körperpflegemitteln', code: '47.75' },
			{
				id: '47.76',
				name: 'Einzelhandel mit Blumen, Pflanzen, Düngemitteln, Tierfutter und Haustieren',
				code: '47.76',
			},
			{ id: '47.77', name: 'Einzelhandel mit Uhren und Schmuck', code: '47.77' },
			{ id: '47.78', name: 'Einzelhandel mit sonstigen Neuwaren', code: '47.78' },
			{ id: '47.79', name: 'Einzelhandel mit Antiquitäten und Gebrauchtwaren', code: '47.79' },
			{ id: '47.8', name: 'Einzelhandel mit Kraftwagen, Krafträdern, deren Teilen und Zubehör', code: '47.8' },
			{ id: '47.81', name: 'Einzelhandel mit Kraftwagen', code: '47.81' },
			{ id: '47.82', name: 'Einzelhandel mit Kraftwagenteilen und -zubehör', code: '47.82' },
			{ id: '47.83', name: 'Einzelhandel mit Krafträdern, Kraftradteilen und -zubehör', code: '47.83' },
			{ id: '47.9', name: 'Vermittlungstätigkeiten für den Einzelhandel', code: '47.9' },
			{
				id: '47.91',
				name: 'Vermittlungstätigkeiten für den Einzelhandel ohne ausgeprägten Schwerpunkt',
				code: '47.91',
			},
			{
				id: '47.92',
				name: 'Vermittlungstätigkeiten für den Einzelhandel mit ausgeprägtem Schwerpunkt',
				code: '47.92',
			},
		],
	},
	{
		id: 'H',
		name: 'Verkehr und Lagerei',
		code: '49-53',
		subcategories: [
			{ id: '49', name: 'Landverkehr und Transport in Rohrfernleitungen', code: '49' },
			{ id: '49.1', name: 'Personenbeförderung im Schienenverkehr', code: '49.1' },
			{ id: '49.11', name: 'Personenbeförderung im Eisenbahnverkehr', code: '49.11' },
			{ id: '49.12', name: 'Sonstige Personenbeförderung im Schienenverkehr', code: '49.12' },
			{ id: '49.2', name: 'Güterbeförderung im Schienenverkehr', code: '49.2' },
			{ id: '49.20', name: 'Güterbeförderung im Schienenverkehr', code: '49.20' },
			{ id: '49.3', name: 'Sonstige Personenbeförderung im Landverkehr', code: '49.3' },
			{ id: '49.31', name: 'Personenbeförderung im Linienverkehr auf der Straße', code: '49.31' },
			{ id: '49.32', name: 'Personenbeförderung im Gelegenheitsverkehr auf der Straße', code: '49.32' },
			{ id: '49.33', name: 'Personenbeförderung mit Fahrzeug mit Fahrer auf Abruf', code: '49.33' },
			{ id: '49.34', name: 'Personenbeförderung mit Seilbahnen und Skiliften', code: '49.34' },
			{ id: '49.39', name: 'Sonstige Personenbeförderung im Landverkehr a. n. g.', code: '49.39' },
			{ id: '49.4', name: 'Güterbeförderung im Straßenverkehr, Umzugstransporte', code: '49.4' },
			{ id: '49.41', name: 'Güterbeförderung im Straßenverkehr', code: '49.41' },
			{ id: '49.42', name: 'Umzugstransporte', code: '49.42' },
			{ id: '49.5', name: 'Transport in Rohrfernleitungen', code: '49.5' },
			{ id: '49.50', name: 'Transport in Rohrfernleitungen', code: '49.50' },
			{ id: '50', name: 'Schifffahrt', code: '50' },
			{ id: '50.1', name: 'Personenbeförderung in der Hochsee- und Küstenschifffahrt', code: '50.1' },
			{ id: '50.10', name: 'Personenbeförderung in der Hochsee- und Küstenschifffahrt', code: '50.10' },
			{ id: '50.2', name: 'Güterbeförderung in der Hochsee- und Küstenschifffahrt', code: '50.2' },
			{ id: '50.20', name: 'Güterbeförderung in der Hochsee- und Küstenschifffahrt', code: '50.20' },
			{ id: '50.3', name: 'Personenbeförderung in der Binnenschifffahrt', code: '50.3' },
			{ id: '50.30', name: 'Personenbeförderung in der Binnenschifffahrt', code: '50.30' },
			{ id: '50.4', name: 'Güterbeförderung in der Binnenschifffahrt', code: '50.4' },
			{ id: '50.40', name: 'Güterbeförderung in der Binnenschifffahrt', code: '50.40' },
			{ id: '51', name: 'Luftfahrt', code: '51' },
			{ id: '51.1', name: 'Personenbeförderung in der Luftfahrt', code: '51.1' },
			{ id: '51.10', name: 'Personenbeförderung in der Luftfahrt', code: '51.10' },
			{ id: '51.2', name: 'Güterbeförderung in der Luftfahrt und Raumtransport', code: '51.2' },
			{ id: '51.21', name: 'Güterbeförderung in der Luftfahrt', code: '51.21' },
			{ id: '51.22', name: 'Raumtransport', code: '51.22' },
			{ id: '52', name: 'Lagerei sowie Erbringung von sonstigen Dienstleistungen für den Verkehr', code: '52' },
			{ id: '52.1', name: 'Lagerei', code: '52.1' },
			{ id: '52.10', name: 'Lagerei', code: '52.10' },
			{ id: '52.2', name: 'Erbringung von sonstigen Dienstleistungen für den Verkehr', code: '52.2' },
			{ id: '52.21', name: 'Erbringung von sonstigen Dienstleistungen für den Landverkehr', code: '52.21' },
			{ id: '52.22', name: 'Erbringung von sonstigen Dienstleistungen für die Schifffahrt', code: '52.22' },
			{ id: '52.23', name: 'Erbringung von sonstigen Dienstleistungen für die Luftfahrt', code: '52.23' },
			{ id: '52.24', name: 'Frachtumschlag', code: '52.24' },
			{ id: '52.25', name: 'Erbringung von Logistikdienstleistungen', code: '52.25' },
			{ id: '52.26', name: 'Erbringung von sonstigen Dienstleistungen für den Verkehr', code: '52.26' },
			{ id: '52.3', name: 'Vermittlungstätigkeiten für den Verkehr', code: '52.3' },
			{ id: '52.31', name: 'Vermittlungstätigkeiten für die Güterbeförderung', code: '52.31' },
			{ id: '52.32', name: 'Vermittlungstätigkeiten für die Personenbeförderung', code: '52.32' },
			{ id: '53', name: 'Post-, Kurier- und Expressdienste', code: '53' },
			{ id: '53.1', name: 'Postdienste von Universaldienstleistungsanbietern', code: '53.1' },
			{ id: '53.10', name: 'Postdienste von Universaldienstleistungsanbietern', code: '53.10' },
			{ id: '53.2', name: 'Sonstige Post-, Kurier- und Expressdienste', code: '53.2' },
			{ id: '53.20', name: 'Sonstige Post-, Kurier- und Expressdienste', code: '53.20' },
			{
				id: '53.3',
				name: 'Vermittlungstätigkeiten für Post-, Kurier- und Expressdienstleistungen',
				code: '53.3',
			},
			{
				id: '53.30',
				name: 'Vermittlungstätigkeiten für Post-, Kurier- und Expressdienstleistungen',
				code: '53.30',
			},
		],
	},
	{
		id: 'I',
		name: 'Gastgewerbe',
		code: '55-56',
		subcategories: [
			{ id: '55', name: 'Beherbergung', code: '55' },
			{ id: '55.1', name: 'Hotels, Gasthöfe und Pensionen', code: '55.1' },
			{ id: '55.10', name: 'Hotels, Gasthöfe und Pensionen', code: '55.10' },
			{ id: '55.2', name: 'Ferienunterkünfte und ähnliche Beherbergungsstätten', code: '55.2' },
			{ id: '55.20', name: 'Ferienunterkünfte und ähnliche Beherbergungsstätten', code: '55.20' },
			{ id: '55.3', name: 'Campingplätze', code: '55.3' },
			{ id: '55.30', name: 'Campingplätze', code: '55.30' },
			{ id: '55.4', name: 'Vermittlungstätigkeiten für Beherbergungsdienstleistungen', code: '55.4' },
			{ id: '55.40', name: 'Vermittlungstätigkeiten für Beherbergungsdienstleistungen', code: '55.40' },
			{ id: '55.9', name: 'Sonstige Beherbergungsstätten', code: '55.9' },
			{ id: '55.90', name: 'Sonstige Beherbergungsstätten', code: '55.90' },
			{ id: '56', name: 'Gastronomie', code: '56' },
			{ id: '56.1', name: 'Restaurants, Gaststätten, Imbissstuben, Cafés, Eissalons u. Ä.', code: '56.1' },
			{ id: '56.11', name: 'Restaurants, Gaststätten, Imbissstuben, Cafés, Eissalons u. Ä.', code: '56.11' },
			{ id: '56.12', name: 'Mobile Gastronomie', code: '56.12' },
			{ id: '56.2', name: 'Caterer und Erbringung sonstiger Verpflegungsdienstleistungen', code: '56.2' },
			{ id: '56.21', name: 'Event-Caterer', code: '56.21' },
			{
				id: '56.22',
				name: 'Sonstige Caterer und Erbringung sonstiger Verpflegungsdienstleistungen',
				code: '56.22',
			},
			{ id: '56.3', name: 'Ausschank von Getränken', code: '56.3' },
			{ id: '56.30', name: 'Ausschank von Getränken', code: '56.30' },
			{ id: '56.4', name: 'Vermittlungstätigkeiten für gastronomische Dienstleistungen', code: '56.4' },
			{ id: '56.40', name: 'Vermittlungstätigkeiten für gastronomische Dienstleistungen', code: '56.40' },
		],
	},
	{
		id: 'J',
		name: 'Verlagswesen, Rundfunk sowie Erstellung und Verbreitung von Medieninhalten',
		code: '58-60',
		subcategories: [
			{ id: '58', name: 'Verlagswesen', code: '58' },
			{
				id: '58.1',
				name: 'Verlegen von Büchern und Zeitungen sowie sonstiges Verlagswesen, ohne Software',
				code: '58.1',
			},
			{ id: '58.11', name: 'Verlegen von Büchern', code: '58.11' },
			{ id: '58.12', name: 'Verlegen von Zeitungen', code: '58.12' },
			{ id: '58.13', name: 'Verlegen von Zeitschriften', code: '58.13' },
			{ id: '58.19', name: 'Sonstiges Verlagswesen, ohne Software', code: '58.19' },
			{ id: '58.2', name: 'Verlegen von Software', code: '58.2' },
			{ id: '58.21', name: 'Verlegen von Computerspielen', code: '58.21' },
			{ id: '58.29', name: 'Verlegen von sonstiger Software', code: '58.29' },
			{
				id: '59',
				name: 'Herstellung, Verleih und Vertrieb von Filmen und Fernsehprogrammen; Kinos; Tonstudios und Verlegen von Musik',
				code: '59',
			},
			{
				id: '59.1',
				name: 'Herstellung von Filmen und Fernsehprogrammen, deren Verleih und Vertrieb, Kinos',
				code: '59.1',
			},
			{ id: '59.11', name: 'Herstellung von Filmen, Videofilmen und Fernsehprogrammen', code: '59.11' },
			{ id: '59.12', name: 'Nachbearbeitung und sonstige Filmtechnik', code: '59.12' },
			{ id: '59.13', name: 'Filmverleih und -vertrieb, nicht an private Haushalte', code: '59.13' },
			{ id: '59.14', name: 'Kinos', code: '59.14' },
			{
				id: '59.2',
				name: 'Tonstudios; Herstellung von Hörfunkbeiträgen; Verlegen von bespielten Tonträgern und Musikalien',
				code: '59.2',
			},
			{
				id: '59.20',
				name: 'Tonstudios; Herstellung von Hörfunkbeiträgen; Verlegen von bespielten Tonträgern und Musikalien',
				code: '59.20',
			},
			{
				id: '60',
				name: 'Rundfunkveranstalter, Nachrichtenagenturen und sonstige Verbreitung von Medieninhalten',
				code: '60',
			},
			{ id: '60.1', name: 'Hörfunkveranstalter und Verbreitung von Audioinhalten', code: '60.1' },
			{ id: '60.10', name: 'Hörfunkveranstalter und Verbreitung von Audioinhalten', code: '60.10' },
			{ id: '60.2', name: 'Fernsehveranstalter und Verbreitung von Videoinhalten', code: '60.2' },
			{ id: '60.20', name: 'Fernsehveranstalter und Verbreitung von Videoinhalten', code: '60.20' },
			{ id: '60.3', name: 'Nachrichtenagenturen und sonstige Verbreitung von Medieninhalten', code: '60.3' },
			{ id: '60.31', name: 'Nachrichtenagenturen', code: '60.31' },
			{ id: '60.39', name: 'Sonstige Verbreitung von Medieninhalten', code: '60.39' },
		],
	},
	{
		id: 'K',
		name: 'Telekommunikation, Softwareentwicklung, IT-Beratung und Erbringung sonstiger Dienstleistungen der Informationstechnologie und der Computerinfrastruktur',
		code: '61-63',
		subcategories: [
			{ id: '61', name: 'Telekommunikation', code: '61' },
			{
				id: '61.1',
				name: 'Leitungsgebundene, drahtlose und satellitengestützte Telekommunikation',
				code: '61.1',
			},
			{
				id: '61.10',
				name: 'Leitungsgebundene, drahtlose und satellitengestützte Telekommunikation',
				code: '61.10',
			},
			{ id: '61.2', name: 'Wiederverkaufs- und Vermittlungstätigkeiten für die Telekommunikation', code: '61.2' },
			{
				id: '61.20',
				name: 'Wiederverkaufs- und Vermittlungstätigkeiten für die Telekommunikation',
				code: '61.20',
			},
			{ id: '61.9', name: 'Sonstige Telekommunikation', code: '61.9' },
			{ id: '61.90', name: 'Sonstige Telekommunikation', code: '61.90' },
			{ id: '62', name: 'Erbringung von Dienstleistungen der Informationstechnologie', code: '62' },
			{ id: '62.1', name: 'Programmierungstätigkeiten', code: '62.1' },
			{ id: '62.10', name: 'Programmierungstätigkeiten', code: '62.10' },
			{
				id: '62.2',
				name: 'Erbringung von Dienstleistungen der IT-Beratung sowie des Betriebs von Datenverarbeitungseinrichtungen',
				code: '62.2',
			},
			{
				id: '62.20',
				name: 'Erbringung von Dienstleistungen der IT-Beratung sowie des Betriebs von Datenverarbeitungseinrichtungen',
				code: '62.20',
			},
			{ id: '62.9', name: 'Erbringung von sonstigen Dienstleistungen der Informationstechnologie', code: '62.9' },
			{
				id: '62.90',
				name: 'Erbringung von sonstigen Dienstleistungen der Informationstechnologie',
				code: '62.90',
			},
			{
				id: '63',
				name: 'Datenverarbeitung, Hosting und Erbringung sonstiger Informationsdienstleistungen',
				code: '63',
			},
			{ id: '63.1', name: 'Datenverarbeitung, Hosting und damit verbundene Tätigkeiten', code: '63.1' },
			{ id: '63.10', name: 'Datenverarbeitung, Hosting und damit verbundene Tätigkeiten', code: '63.10' },
			{
				id: '63.9',
				name: 'Web-Suchportale und Erbringung von sonstigen Informationsdienstleistungen',
				code: '63.9',
			},
			{ id: '63.91', name: 'Web-Suchportale', code: '63.91' },
			{ id: '63.92', name: 'Erbringung von sonstigen Informationsdienstleistungen', code: '63.92' },
		],
	},
	{
		id: 'L',
		name: 'Erbringung von Finanz- und Versicherungsdienstleistungen',
		code: '64-66',
		subcategories: [
			{ id: '64', name: 'Erbringung von Finanzdienstleistungen', code: '64' },
			{ id: '64.1', name: 'Zentralbanken und Kreditinstitute', code: '64.1' },
			{ id: '64.11', name: 'Zentralbanken', code: '64.11' },
			{ id: '64.19', name: 'Kreditinstitute, ohne Spezialkreditinstitute', code: '64.19' },
			{ id: '64.2', name: 'Beteiligungsgesellschaften und Finanzierungs-Conduits', code: '64.2' },
			{ id: '64.21', name: 'Beteiligungsgesellschaften', code: '64.21' },
			{ id: '64.22', name: 'Finanzierungs-Conduits', code: '64.22' },
			{ id: '64.3', name: 'Treuhand- und sonstige Fonds u. ä. Finanzinstitutionen', code: '64.3' },
			{ id: '64.31', name: 'Investmentfonds', code: '64.31' },
			{ id: '64.32', name: 'Treuhandfonds, Nachlass- und Treuhandkonten', code: '64.32' },
			{ id: '64.9', name: 'Sonstige Finanzierungsinstitutionen', code: '64.9' },
			{ id: '64.91', name: 'Institutionen für Finanzierungsleasing', code: '64.91' },
			{ id: '64.92', name: 'Spezialkreditinstitute', code: '64.92' },
			{ id: '64.99', name: 'Sonstige Finanzdienstleistungen a. n. g.', code: '64.99' },
			{
				id: '65',
				name: 'Versicherungen, Rückversicherungen und Pensionskassen, ohne Sozialversicherung',
				code: '65',
			},
			{ id: '65.1', name: 'Versicherungen', code: '65.1' },
			{ id: '65.11', name: 'Lebensversicherung', code: '65.11' },
			{ id: '65.12', name: 'Nichtlebensversicherungen', code: '65.12' },
			{ id: '65.2', name: 'Rückversicherungen', code: '65.2' },
			{ id: '65.20', name: 'Rückversicherungen', code: '65.20' },
			{ id: '65.3', name: 'Pensionskassen und Pensionsfonds', code: '65.3' },
			{ id: '65.30', name: 'Pensionskassen und Pensionsfonds', code: '65.30' },
			{ id: '66', name: 'Mit Finanz- und Versicherungsdienstleistungen verbundene Tätigkeiten', code: '66' },
			{ id: '66.1', name: 'Mit Finanzdienstleistungen verbundene Tätigkeiten', code: '66.1' },
			{ id: '66.11', name: 'Effekten- und Warenbörsen', code: '66.11' },
			{ id: '66.12', name: 'Effekten- und Warenterminhandel', code: '66.12' },
			{ id: '66.19', name: 'Sonstige mit Finanzdienstleistungen verbundene Tätigkeiten', code: '66.19' },
			{
				id: '66.2',
				name: 'Mit Versicherungsdienstleistungen und Pensionskassen verbundene Tätigkeiten',
				code: '66.2',
			},
			{ id: '66.21', name: 'Risiko- und Schadensbewertung', code: '66.21' },
			{ id: '66.22', name: 'Tätigkeiten der Versicherungsvermittlung', code: '66.22' },
			{
				id: '66.29',
				name: 'Mit Versicherungsdienstleistungen und Pensionskassen verbundene Tätigkeiten a. n. g.',
				code: '66.29',
			},
			{ id: '66.3', name: 'Fondsmanagement', code: '66.3' },
			{ id: '66.30', name: 'Fondsmanagement', code: '66.30' },
		],
	},
	{
		id: 'M',
		name: 'Grundstücks- und Wohnungswesen',
		code: '68',
		subcategories: [
			{ id: '68', name: 'Grundstücks- und Wohnungswesen', code: '68' },
			{
				id: '68.1',
				name: 'Kauf und Verkauf von eigenen Grundstücken, Gebäuden und Wohnungen sowie Erschließung von Grundstücken',
				code: '68.1',
			},
			{ id: '68.11', name: 'Kauf und Verkauf von eigenen Grundstücken, Gebäuden und Wohnungen', code: '68.11' },
			{ id: '68.12', name: 'Erschließung von Grundstücken; Bauträger', code: '68.12' },
			{
				id: '68.2',
				name: 'Vermietung, Verpachtung von eigenen oder geleasten Grundstücken, Gebäuden und Wohnungen',
				code: '68.2',
			},
			{
				id: '68.20',
				name: 'Vermietung, Verpachtung von eigenen oder geleasten Grundstücken, Gebäuden und Wohnungen',
				code: '68.20',
			},
			{
				id: '68.3',
				name: 'Vermittlung und Verwaltung von Grundstücken, Gebäuden und Wohnungen für Dritte',
				code: '68.3',
			},
			{ id: '68.31', name: 'Vermittlung von Grundstücken, Gebäuden und Wohnungen für Dritte', code: '68.31' },
			{ id: '68.32', name: 'Verwaltung von Grundstücken, Gebäuden und Wohnungen für Dritte', code: '68.32' },
		],
	},
	{
		id: 'N',
		name: 'Erbringung von wissenschaftlichen und technischen Dienstleistungen',
		code: '69-75',
		subcategories: [
			{ id: '69', name: 'Rechts- und Steuerberatung, Wirtschaftsprüfung', code: '69' },
			{ id: '69.1', name: 'Rechtsberatung', code: '69.1' },
			{ id: '69.10', name: 'Rechtsberatung', code: '69.10' },
			{ id: '69.2', name: 'Wirtschaftsprüfung und Steuerberatung; Buchführung', code: '69.2' },
			{ id: '69.20', name: 'Wirtschaftsprüfung und Steuerberatung; Buchführung', code: '69.20' },
			{
				id: '70',
				name: 'Verwaltung und Führung von Unternehmen und Betrieben; Unternehmensberatung',
				code: '70',
			},
			{ id: '70.1', name: 'Verwaltung und Führung von Unternehmen und Betrieben', code: '70.1' },
			{ id: '70.10', name: 'Verwaltung und Führung von Unternehmen und Betrieben', code: '70.10' },
			{ id: '70.2', name: 'Unternehmensberatung', code: '70.2' },
			{ id: '70.20', name: 'Unternehmensberatung', code: '70.20' },
			{
				id: '71',
				name: 'Tätigkeiten von Architektur- und Ingenieurbüros; technische, physikalische und chemische Untersuchung',
				code: '71',
			},
			{ id: '71.1', name: 'Tätigkeiten von Architektur- und Ingenieurbüros', code: '71.1' },
			{ id: '71.11', name: 'Tätigkeiten von Architekturbüros', code: '71.11' },
			{ id: '71.12', name: 'Tätigkeiten von Ingenieurbüros', code: '71.12' },
			{ id: '71.2', name: 'Technische, physikalische und chemische Untersuchung', code: '71.2' },
			{ id: '71.20', name: 'Technische, physikalische und chemische Untersuchung', code: '71.20' },
			{ id: '72', name: 'Forschung und Entwicklung', code: '72' },
			{
				id: '72.1',
				name: 'Forschung und Entwicklung im Bereich Natur-, Ingenieur-, Agrarwissenschaften und Medizin',
				code: '72.1',
			},
			{
				id: '72.10',
				name: 'Forschung und Entwicklung im Bereich Natur-, Ingenieur-, Agrarwissenschaften und Medizin',
				code: '72.10',
			},
			{
				id: '72.2',
				name: 'Forschung und Entwicklung im Bereich Rechts-, Wirtschafts- und Sozialwissenschaften sowie im Bereich Sprach-, Kultur- und Kunstwissenschaften',
				code: '72.2',
			},
			{
				id: '72.20',
				name: 'Forschung und Entwicklung im Bereich Rechts-, Wirtschafts- und Sozialwissenschaften sowie im Bereich Sprach-, Kultur- und Kunstwissenschaften',
				code: '72.20',
			},
			{ id: '73', name: 'Werbung und Marktforschung sowie Public-Relations-Beratung', code: '73' },
			{ id: '73.1', name: 'Werbung', code: '73.1' },
			{ id: '73.11', name: 'Tätigkeiten von Werbeagenturen', code: '73.11' },
			{ id: '73.12', name: 'Vermarktung und Vermittlung von Werbezeiten und Werbeflächen', code: '73.12' },
			{ id: '73.2', name: 'Markt- und Meinungsforschung', code: '73.2' },
			{ id: '73.20', name: 'Markt- und Meinungsforschung', code: '73.20' },
			{ id: '73.3', name: 'Public-Relations-Beratung', code: '73.3' },
			{ id: '73.30', name: 'Public-Relations-Beratung', code: '73.30' },
			{ id: '74', name: 'Sonstige wissenschaftliche und technische Tätigkeiten', code: '74' },
			{ id: '74.1', name: 'Ateliers für Textil-, Schmuck-, Grafik- u. ä. Design', code: '74.1' },
			{ id: '74.11', name: 'Industrie-, Produkt- und Modedesign', code: '74.11' },
			{ id: '74.12', name: 'Grafik- und Kommunikationsdesign', code: '74.12' },
			{ id: '74.13', name: 'Innenraumdesign und Raumgestaltung', code: '74.13' },
			{ id: '74.14', name: 'Sonstige spezialisierte Designtätigkeiten', code: '74.14' },
			{ id: '74.2', name: 'Fotografie und Fotolabors', code: '74.2' },
			{ id: '74.20', name: 'Fotografie und Fotolabors', code: '74.20' },
			{ id: '74.3', name: 'Übersetzen und Dolmetschen', code: '74.3' },
			{ id: '74.30', name: 'Übersetzen und Dolmetschen', code: '74.30' },
			{ id: '74.9', name: 'Sonstige wissenschaftliche und technische Tätigkeiten a. n. g.', code: '74.9' },
			{
				id: '74.91',
				name: 'Erbringung von Vermittlungs- und Vermarktungsdienstleistungen für Patente',
				code: '74.91',
			},
			{
				id: '74.99',
				name: 'Alle anderen wissenschaftlichen und technischen Tätigkeiten a. n. g.',
				code: '74.99',
			},
			{ id: '75', name: 'Veterinärwesen', code: '75' },
			{ id: '75.0', name: 'Veterinärwesen', code: '75.0' },
			{ id: '75.00', name: 'Veterinärwesen', code: '75.00' },
		],
	},
	{
		id: 'O',
		name: 'Erbringung von sonstigen wirtschaftlichen Dienstleistungen',
		code: '77-82',
		subcategories: [
			{ id: '77', name: 'Vermietung und Leasing', code: '77' },
			{ id: '77.1', name: 'Vermietung von Kraftwagen', code: '77.1' },
			{
				id: '77.11',
				name: 'Vermietung von Kraftwagen mit einem Gesamtgewicht von 3,5 t oder weniger',
				code: '77.11',
			},
			{
				id: '77.12',
				name: 'Vermietung von Kraftwagen mit einem Gesamtgewicht von mehr als 3,5 t',
				code: '77.12',
			},
			{ id: '77.2', name: 'Vermietung von Gebrauchsgütern', code: '77.2' },
			{ id: '77.21', name: 'Vermietung von Sport- und Freizeitgeräten', code: '77.21' },
			{ id: '77.22', name: 'Vermietung von sonstigen Gebrauchsgütern', code: '77.22' },
			{ id: '77.3', name: 'Vermietung von Maschinen, Geräten und sonstigen beweglichen Sachen', code: '77.3' },
			{ id: '77.31', name: 'Vermietung von landwirtschaftlichen Maschinen und Geräten', code: '77.31' },
			{ id: '77.32', name: 'Vermietung von Baumaschinen und -geräten', code: '77.32' },
			{
				id: '77.33',
				name: 'Vermietung von Büromaschinen, Datenverarbeitungsgeräten und -einrichtungen',
				code: '77.33',
			},
			{ id: '77.34', name: 'Vermietung von Wasserfahrzeugen', code: '77.34' },
			{ id: '77.35', name: 'Vermietung von Luftfahrzeugen', code: '77.35' },
			{
				id: '77.39',
				name: 'Vermietung von sonstigen Maschinen, Geräten und beweglichen Sachen a. n. g.',
				code: '77.39',
			},
			{
				id: '77.4',
				name: 'Leasing von nichtfinanziellen immateriellen Vermögensgütern, ohne Copyrights',
				code: '77.4',
			},
			{
				id: '77.40',
				name: 'Leasing von nichtfinanziellen immateriellen Vermögensgütern, ohne Copyrights',
				code: '77.40',
			},
			{
				id: '77.5',
				name: 'Vermittlungstätigkeiten für die Vermietung und das Leasing von beweglichen Sachen und nichtfinanziellen immateriellen Vermögenswerten',
				code: '77.5',
			},
			{
				id: '77.51',
				name: 'Vermittlungstätigkeiten für die Vermietung und das Leasing von Autos, Wohnmobilen und Anhängern',
				code: '77.51',
			},
			{
				id: '77.52',
				name: 'Vermittlungstätigkeiten für die Vermietung und das Leasing von sonstigen beweglichen Sachen und nichtfinanziellen immateriellen Vermögensgütern',
				code: '77.52',
			},
			{ id: '78', name: 'Vermittlung und Überlassung von Arbeitskräften', code: '78' },
			{ id: '78.1', name: 'Vermittlung von Arbeitskräften', code: '78.1' },
			{ id: '78.10', name: 'Vermittlung von Arbeitskräften', code: '78.10' },
			{ id: '78.2', name: 'Überlassung von Arbeitskräften und sonstige Personaldienstleistungen', code: '78.2' },
			{
				id: '78.20',
				name: 'Überlassung von Arbeitskräften und sonstige Personaldienstleistungen',
				code: '78.20',
			},
			{
				id: '79',
				name: 'Reisebüros, Reiseveranstalter und Erbringung sonstiger Reservierungsdienstleistungen',
				code: '79',
			},
			{ id: '79.1', name: 'Reisebüros und Reiseveranstalter', code: '79.1' },
			{ id: '79.11', name: 'Reisebüros', code: '79.11' },
			{ id: '79.12', name: 'Reiseveranstalter', code: '79.12' },
			{ id: '79.9', name: 'Erbringung sonstiger Reservierungsdienstleistungen', code: '79.9' },
			{ id: '79.90', name: 'Erbringung sonstiger Reservierungsdienstleistungen', code: '79.90' },
			{ id: '80', name: 'Wach- und Sicherheitsdienste sowie Detekteien', code: '80' },
			{ id: '80.0', name: 'Wach- und Sicherheitsdienste sowie Detekteien', code: '80.0' },
			{ id: '80.01', name: 'Private Wach- und Sicherheitsdienste sowie Detekteien', code: '80.01' },
			{ id: '80.09', name: 'Sicherheitsdienste a. n. g.', code: '80.09' },
			{ id: '81', name: 'Gebäudebetreuung; Garten- und Landschaftsbau', code: '81' },
			{ id: '81.1', name: 'Hausmeisterdienste', code: '81.1' },
			{ id: '81.10', name: 'Hausmeisterdienste', code: '81.10' },
			{ id: '81.2', name: 'Reinigung von Gebäuden, Straßen und Verkehrsmitteln', code: '81.2' },
			{ id: '81.21', name: 'Allgemeine Gebäudereinigung', code: '81.21' },
			{ id: '81.22', name: 'Spezielle Reinigung von Gebäuden und Reinigung von Maschinen', code: '81.22' },
			{ id: '81.23', name: 'Sonstige Reinigung', code: '81.23' },
			{
				id: '81.3',
				name: 'Garten- und Landschaftsbau sowie Erbringung von sonstigen gärtnerischen Dienstleistungen',
				code: '81.3',
			},
			{
				id: '81.30',
				name: 'Garten- und Landschaftsbau sowie Erbringung von sonstigen gärtnerischen Dienstleistungen',
				code: '81.30',
			},
			{
				id: '82',
				name: 'Erbringung von wirtschaftlichen Dienstleistungen für Unternehmen und Privatpersonen',
				code: '82',
			},
			{ id: '82.1', name: 'Sekretariats- und Schreibdienste, Copy-Shops', code: '82.1' },
			{ id: '82.10', name: 'Sekretariats- und Schreibdienste, Copy-Shops', code: '82.10' },
			{ id: '82.2', name: 'Call Centers', code: '82.2' },
			{ id: '82.20', name: 'Call Centers', code: '82.20' },
			{ id: '82.3', name: 'Messe-, Kongress- und Business-Event-Veranstalter', code: '82.3' },
			{ id: '82.30', name: 'Messe-, Kongress- und Business-Event-Veranstalter', code: '82.30' },
			{
				id: '82.4',
				name: 'Vermittlungstätigkeiten für die Erbringung von wirtschaftlichen Dienstleistungen für Unternehmen und Privatpersonen a. n. g.',
				code: '82.4',
			},
			{
				id: '82.40',
				name: 'Vermittlungstätigkeiten für die Erbringung von wirtschaftlichen Dienstleistungen für Unternehmen und Privatpersonen a. n. g.',
				code: '82.40',
			},
			{
				id: '82.9',
				name: 'Erbringung wirtschaftlicher Dienstleistungen für Unternehmen und Privatpersonen a. n. g.',
				code: '82.9',
			},
			{ id: '82.91', name: 'Inkassobüros und Auskunfteien', code: '82.91' },
			{ id: '82.92', name: 'Abfüllen und Verpacken', code: '82.92' },
			{
				id: '82.99',
				name: 'Erbringung sonstiger wirtschaftlicher Dienstleistungen für Unternehmen und Privatpersonen a. n. g.',
				code: '82.99',
			},
		],
	},
	{
		id: 'P',
		name: 'Öffentliche Verwaltung, Verteidigung; Sozialversicherung',
		code: '84',
		subcategories: [
			{ id: '84', name: 'Öffentliche Verwaltung, Verteidigung; Sozialversicherung', code: '84' },
			{ id: '84.1', name: 'Öffentliche Verwaltung', code: '84.1' },
			{ id: '84.11', name: 'Allgemeine öffentliche Verwaltung', code: '84.11' },
			{
				id: '84.12',
				name: 'Öffentliche Verwaltung auf den Gebieten Gesundheitswesen, Bildung, Kultur und Sozialwesen',
				code: '84.12',
			},
			{ id: '84.13', name: 'Wirtschaftsförderung, -ordnung und -aufsicht', code: '84.13' },
			{
				id: '84.2',
				name: 'Auswärtige Angelegenheiten, Verteidigung, Rechtspflege, öffentliche Sicherheit und Ordnung',
				code: '84.2',
			},
			{ id: '84.21', name: 'Auswärtige Angelegenheiten', code: '84.21' },
			{ id: '84.22', name: 'Verteidigung', code: '84.22' },
			{ id: '84.23', name: 'Rechtspflege', code: '84.23' },
			{ id: '84.24', name: 'Öffentliche Sicherheit und Ordnung', code: '84.24' },
			{ id: '84.25', name: 'Feuerwehren', code: '84.25' },
			{ id: '84.3', name: 'Sozialversicherung', code: '84.3' },
			{ id: '84.30', name: 'Sozialversicherung', code: '84.30' },
		],
	},
	{
		id: 'Q',
		name: 'Erziehung und Unterricht',
		code: '85',
		subcategories: [
			{ id: '85', name: 'Erziehung und Unterricht', code: '85' },
			{ id: '85.1', name: 'Kindergärten und Vorschulen', code: '85.1' },
			{ id: '85.10', name: 'Kindergärten und Vorschulen', code: '85.10' },
			{ id: '85.2', name: 'Grundschulen', code: '85.2' },
			{ id: '85.20', name: 'Grundschulen', code: '85.20' },
			{ id: '85.3', name: 'Weiterführende Schulen und postsekundärer, nicht tertiärer Unterricht', code: '85.3' },
			{ id: '85.31', name: 'Allgemeinbildende weiterführende Schulen', code: '85.31' },
			{ id: '85.32', name: 'Berufsbildende weiterführende Schulen', code: '85.32' },
			{ id: '85.33', name: 'Postsekundärer, nicht tertiärer Unterricht', code: '85.33' },
			{ id: '85.4', name: 'Tertiärer Unterricht', code: '85.4' },
			{ id: '85.40', name: 'Tertiärer Unterricht', code: '85.40' },
			{ id: '85.5', name: 'Sonstiger Unterricht', code: '85.5' },
			{ id: '85.51', name: 'Sport- und Freizeitunterricht', code: '85.51' },
			{ id: '85.52', name: 'Kulturunterricht', code: '85.52' },
			{ id: '85.53', name: 'Fahr- und Flugschulen', code: '85.53' },
			{ id: '85.59', name: 'Sonstiger Unterricht a. n. g.', code: '85.59' },
			{ id: '85.6', name: 'Erbringung von Dienstleistungen für Erziehung und Unterricht', code: '85.6' },
			{ id: '85.61', name: 'Vermittlungstätigkeiten für Erziehung und Unterricht', code: '85.61' },
			{
				id: '85.69',
				name: 'Erbringung von Dienstleistungen für Erziehung und Unterricht a. n. g.',
				code: '85.69',
			},
		],
	},
	{
		id: 'R',
		name: 'Gesundheits- und Sozialwesen',
		code: '86-88',
		subcategories: [
			{ id: '86', name: 'Gesundheitswesen', code: '86' },
			{ id: '86.1', name: 'Krankenhäuser', code: '86.1' },
			{ id: '86.10', name: 'Krankenhäuser', code: '86.10' },
			{ id: '86.2', name: 'Arzt- und Zahnarztpraxen', code: '86.2' },
			{ id: '86.21', name: 'Arztpraxen für Allgemeinmedizin', code: '86.21' },
			{ id: '86.22', name: 'Facharztpraxen', code: '86.22' },
			{ id: '86.23', name: 'Zahnarztpraxen', code: '86.23' },
			{ id: '86.9', name: 'Sonstiges Gesundheitswesen', code: '86.9' },
			{
				id: '86.91',
				name: 'Erbringung von Dienstleistungen der diagnostischen Bildgebung sowie von medizinischen Laboratorien',
				code: '86.91',
			},
			{ id: '86.92', name: 'Rettungs- und Krankentransportdienste', code: '86.92' },
			{
				id: '86.93',
				name: 'Erbringung von Dienstleistungen von Psychotherapeutinnen und -therapeuten, klinischen und Gesundheitspsychologinnen und -psychologen, ohne ärztliche Therapien',
				code: '86.93',
			},
			{ id: '86.94', name: 'Krankenpflege, Geburtshilfe und Hebammen', code: '86.94' },
			{ id: '86.95', name: 'Erbringung von physiotherapeutischen Dienstleistungen', code: '86.95' },
			{
				id: '86.96',
				name: 'Traditionelle, komplementäre und alternative medizinische Tätigkeiten',
				code: '86.96',
			},
			{
				id: '86.97',
				name: 'Vermittlungstätigkeiten für medizinische, zahnärztliche und andere Gesundheitstätigkeiten',
				code: '86.97',
			},
			{ id: '86.99', name: 'Sonstiges Gesundheitswesen a. n. g.', code: '86.99' },
			{ id: '87', name: 'Heime, ohne Erholungs- und Ferienheime', code: '87' },
			{ id: '87.1', name: 'Pflegeheime', code: '87.1' },
			{ id: '87.10', name: 'Pflegeheime', code: '87.10' },
			{
				id: '87.2',
				name: 'Stationäre Einrichtungen zur psychosozialen Betreuung, Suchtbekämpfung',
				code: '87.2',
			},
			{
				id: '87.20',
				name: 'Stationäre Einrichtungen zur psychosozialen Betreuung, Suchtbekämpfung',
				code: '87.20',
			},
			{ id: '87.3', name: 'Seniorenwohnheime und Wohnheime für Menschen mit Behinderung', code: '87.3' },
			{ id: '87.30', name: 'Seniorenwohnheime und Wohnheime für Menschen mit Behinderung', code: '87.30' },
			{
				id: '87.9',
				name: 'Sonstige Heime, ohne Erholungs- und Ferienheime, und Tätigkeiten für stationäre Betreuung',
				code: '87.9',
			},
			{ id: '87.91', name: 'Vermittlungstätigkeiten für Heime und stationäre Betreuung', code: '87.91' },
			{ id: '87.99', name: 'Sonstige Heime, ohne Erholungs- und Ferienheime, a. n. g.', code: '87.99' },
			{ id: '88', name: 'Sozialwesen, ohne Heime', code: '88' },
			{
				id: '88.1',
				name: 'Soziale Betreuung von älteren Menschen und von Menschen mit Behinderung',
				code: '88.1',
			},
			{
				id: '88.10',
				name: 'Soziale Betreuung von älteren Menschen und von Menschen mit Behinderung',
				code: '88.10',
			},
			{ id: '88.9', name: 'Sonstiges Sozialwesen, ohne Heime', code: '88.9' },
			{ id: '88.91', name: 'Tagesbetreuung von Kindern', code: '88.91' },
			{ id: '88.99', name: 'Sonstiges Sozialwesen a. n. g.', code: '88.99' },
		],
	},
	{
		id: 'S',
		name: 'Kunst, Sport und Erholung',
		code: '90-93',
		subcategories: [
			{ id: '90', name: 'Kunstschaffende Tätigkeiten und Tätigkeiten in der darstellenden Kunst', code: '90' },
			{ id: '90.1', name: 'Kunstschaffende Tätigkeiten', code: '90.1' },
			{ id: '90.11', name: 'Literarisches Schaffen und Musikkomposition', code: '90.11' },
			{ id: '90.12', name: 'Bildende Kunst', code: '90.12' },
			{ id: '90.13', name: 'Sonstige kunstschaffende Tätigkeiten', code: '90.13' },
			{ id: '90.2', name: 'Darstellende Kunst', code: '90.2' },
			{ id: '90.20', name: 'Darstellende Kunst', code: '90.20' },
			{
				id: '90.3',
				name: 'Erbringung von Dienstleistungen für kunstschaffende Tätigkeiten und darstellende Künste',
				code: '90.3',
			},
			{
				id: '90.31',
				name: 'Betrieb von Einrichtungen für kunstschaffende Tätigkeiten und darstellende Künste',
				code: '90.31',
			},
			{
				id: '90.39',
				name: 'Erbringung von sonstigen Dienstleistungen für kunstschaffende Tätigkeiten und darstellende Künste',
				code: '90.39',
			},
			{ id: '91', name: 'Bibliotheken, Archive, Museen, botanische und zoologische Gärten', code: '91' },
			{ id: '91.1', name: 'Bibliotheken und Archive', code: '91.1' },
			{ id: '91.11', name: 'Bibliotheken', code: '91.11' },
			{ id: '91.12', name: 'Archive', code: '91.12' },
			{ id: '91.2', name: 'Museen, Sammlungen, historische Stätten und Denkmäler', code: '91.2' },
			{ id: '91.21', name: 'Museen und Sammlungen', code: '91.21' },
			{ id: '91.22', name: 'Historische Stätten und Denkmäler', code: '91.22' },
			{
				id: '91.3',
				name: 'Konservierung, Restaurierung und sonstige unterstützende Tätigkeiten für das kulturelle Erbe',
				code: '91.3',
			},
			{
				id: '91.30',
				name: 'Konservierung, Restaurierung und sonstige unterstützende Tätigkeiten für das kulturelle Erbe',
				code: '91.30',
			},
			{ id: '91.4', name: 'Botanische und zoologische Gärten sowie Naturparks', code: '91.4' },
			{ id: '91.41', name: 'Botanische und zoologische Gärten', code: '91.41' },
			{ id: '91.42', name: 'Naturparks', code: '91.42' },
			{ id: '92', name: 'Spiel-, Wett- und Lotteriewesen', code: '92' },
			{ id: '92.0', name: 'Spiel-, Wett- und Lotteriewesen', code: '92.0' },
			{ id: '92.00', name: 'Spiel-, Wett- und Lotteriewesen', code: '92.00' },
			{
				id: '93',
				name: 'Erbringung von Dienstleistungen des Sports, der Unterhaltung und der Erholung',
				code: '93',
			},
			{ id: '93.1', name: 'Erbringung von Dienstleistungen des Sports', code: '93.1' },
			{ id: '93.11', name: 'Betrieb von Sportanlagen', code: '93.11' },
			{ id: '93.12', name: 'Sportvereine', code: '93.12' },
			{ id: '93.13', name: 'Fitnesszentren', code: '93.13' },
			{ id: '93.19', name: 'Erbringung von Dienstleistungen des Sports a. n. g.', code: '93.19' },
			{
				id: '93.2',
				name: 'Erbringung von sonstigen Dienstleistungen der Unterhaltung und der Erholung',
				code: '93.2',
			},
			{ id: '93.21', name: 'Vergnügungs- und Themenparks', code: '93.21' },
			{
				id: '93.29',
				name: 'Erbringung von sonstigen Dienstleistungen der Unterhaltung und der Erholung a. n. g.',
				code: '93.29',
			},
		],
	},
	{
		id: 'T',
		name: 'Erbringung von sonstigen Dienstleistungen',
		code: '94-96',
		subcategories: [
			{
				id: '94',
				name: 'Interessenvertretungen sowie kirchliche und sonstige religiöse Vereinigungen, ohne Sozialwesen und Sport',
				code: '94',
			},
			{ id: '94.1', name: 'Wirtschafts- und Arbeitgeberverbände, Berufsorganisationen', code: '94.1' },
			{ id: '94.11', name: 'Wirtschafts- und Arbeitgeberverbände', code: '94.11' },
			{ id: '94.12', name: 'Berufsorganisationen', code: '94.12' },
			{ id: '94.2', name: 'Arbeitnehmervereinigungen', code: '94.2' },
			{ id: '94.20', name: 'Arbeitnehmervereinigungen', code: '94.20' },
			{
				id: '94.9',
				name: 'Kirchliche Vereinigungen; politische Parteien sowie sonstige Interessenvertretungen und Vereinigungen',
				code: '94.9',
			},
			{ id: '94.91', name: 'Kirchliche und sonstige religiöse Vereinigungen', code: '94.91' },
			{ id: '94.92', name: 'Politische Parteien und Vereinigungen', code: '94.92' },
			{ id: '94.99', name: 'Sonstige Interessenvertretungen und Vereinigungen a. n. g.', code: '94.99' },
			{
				id: '95',
				name: 'Reparatur und Instandhaltung von Datenverarbeitungsgeräten und Gebrauchsgütern sowie von Kraftwagen und Krafträdern',
				code: '95',
			},
			{
				id: '95.1',
				name: 'Reparatur und Instandhaltung von Datenverarbeitungs- und Telekommunikationsgeräten',
				code: '95.1',
			},
			{
				id: '95.10',
				name: 'Reparatur und Instandhaltung von Datenverarbeitungs- und Telekommunikationsgeräten',
				code: '95.10',
			},
			{ id: '95.2', name: 'Reparatur und Instandhaltung von Gebrauchsgütern', code: '95.2' },
			{
				id: '95.21',
				name: 'Reparatur und Instandhaltung von Geräten der Unterhaltungselektronik',
				code: '95.21',
			},
			{
				id: '95.22',
				name: 'Reparatur und Instandhaltung von elektrischen Haushaltsgeräten und Gartengeräten',
				code: '95.22',
			},
			{ id: '95.23', name: 'Reparatur und Instandhaltung von Schuhen und Lederwaren', code: '95.23' },
			{
				id: '95.24',
				name: 'Reparatur und Instandhaltung von Möbeln und Einrichtungsgegenständen',
				code: '95.24',
			},
			{ id: '95.25', name: 'Reparatur und Instandhaltung von Uhren und Schmuck', code: '95.25' },
			{ id: '95.29', name: 'Reparatur und Instandhaltung von Gebrauchsgütern a. n. g.', code: '95.29' },
			{ id: '95.3', name: 'Reparatur und Instandhaltung von Kraftwagen und Krafträdern', code: '95.3' },
			{ id: '95.31', name: 'Reparatur und Instandhaltung von Kraftwagen', code: '95.31' },
			{ id: '95.32', name: 'Reparatur und Instandhaltung von Krafträdern', code: '95.32' },
			{
				id: '95.4',
				name: 'Vermittlungstätigkeiten für die Reparatur und Instandhaltung von Datenverarbeitungsgeräten und Gebrauchsgütern sowie von Kraftwagen und Krafträdern',
				code: '95.4',
			},
			{
				id: '95.40',
				name: 'Vermittlungstätigkeiten für die Reparatur und Instandhaltung von Datenverarbeitungsgeräten und Gebrauchsgütern sowie von Kraftwagen und Krafträdern',
				code: '95.40',
			},
			{ id: '96', name: 'Erbringung von überwiegend persönlichen Dienstleistungen', code: '96' },
			{ id: '96.1', name: 'Wäscherei und chemische Reinigung', code: '96.1' },
			{ id: '96.10', name: 'Wäscherei und chemische Reinigung', code: '96.10' },
			{ id: '96.2', name: 'Frisör- und Kosmetiksalons, Day Spas u. Ä.', code: '96.2' },
			{ id: '96.21', name: 'Frisör- und Barbiersalons', code: '96.21' },
			{ id: '96.22', name: 'Kosmetiksalons und ähnliche Schönheitsbehandlungen', code: '96.22' },
			{ id: '96.23', name: 'Day Spas, Saunas, Dampfbäder', code: '96.23' },
			{ id: '96.3', name: 'Bestattungswesen', code: '96.3' },
			{ id: '96.30', name: 'Bestattungswesen', code: '96.30' },
			{ id: '96.4', name: 'Vermittlungstätigkeiten für überwiegend persönliche Dienstleistungen', code: '96.4' },
			{
				id: '96.40',
				name: 'Vermittlungstätigkeiten für überwiegend persönliche Dienstleistungen',
				code: '96.40',
			},
			{ id: '96.9', name: 'Erbringung von sonstigen überwiegend persönlichen Dienstleistungen', code: '96.9' },
			{ id: '96.91', name: 'Erbringung von haushaltsbezogenen Dienstleistungen', code: '96.91' },
			{
				id: '96.99',
				name: 'Erbringung von sonstigen überwiegend persönlichen Dienstleistungen a. n. g.',
				code: '96.99',
			},
		],
	},
	{
		id: 'U',
		name: 'Private Haushalte mit Haushaltspersonal sowie Herstellung von Waren und Erbringung von Dienstleistungen durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
		code: '97-98',
		subcategories: [
			{ id: '97', name: 'Private Haushalte mit Hauspersonal', code: '97' },
			{ id: '97.0', name: 'Private Haushalte mit Hauspersonal', code: '97.0' },
			{ id: '97.00', name: 'Private Haushalte mit Hauspersonal', code: '97.00' },
			{
				id: '98',
				name: 'Herstellung von Waren und Erbringung von Dienstleistungen durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
				code: '98',
			},
			{
				id: '98.1',
				name: 'Herstellung von Waren durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
				code: '98.1',
			},
			{
				id: '98.10',
				name: 'Herstellung von Waren durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
				code: '98.10',
			},
			{
				id: '98.2',
				name: 'Erbringungen von Dienstleistungen durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
				code: '98.2',
			},
			{
				id: '98.20',
				name: 'Erbringungen von Dienstleistungen durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
				code: '98.20',
			},
		],
	},
	{
		id: 'V',
		name: 'Exterritoriale Organisationen und Körperschaften',
		code: '99',
		subcategories: [
			{ id: '99', name: 'Exterritoriale Organisationen und Körperschaften', code: '99' },
			{ id: '99.0', name: 'Exterritoriale Organisationen und Körperschaften', code: '99.0' },
			{ id: '99.00', name: 'Exterritoriale Organisationen und Körperschaften', code: '99.00' },
		],
	},
];

/**
 * Get all HR industry items flattened for search
 * @returns {Array} Flattened array of all subcategories with their main category
 */
export const getAllHRIndustries = () => {
	const industries = [];
	HR_SEARCH_INDUSTRY_CATEGORIES.forEach((mainCategory) => {
		mainCategory.subcategories.forEach((sub) => {
			industries.push({
				...sub,
				mainCategory: mainCategory.name,
				mainCategoryId: mainCategory.id,
			});
		});
	});
	return industries;
};

/**
 * Get all codes for a main category
 * @param {string} mainCategoryId - The main category ID (A-V)
 * @returns {Array} Array of all codes in that category
 */
export const getCodesForHRMainCategory = (mainCategoryId) => {
	const category = HR_SEARCH_INDUSTRY_CATEGORIES.find((cat) => cat.id === mainCategoryId);
	return category ? category.subcategories.map((sub) => sub.code) : [];
};
